import React, { useState, useEffect, useCallback, useMemo } from "react";
import {
  Button,
  Tooltip,
  IconButton,
  Grid,
  TextField,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tabs,
  Tab,
  FormHelperText,
  FormLabel,
  FormControl,
  CircularProgress,
  Checkbox,
  FormGroup,
  Avatar,
  Modal,
  MenuItem,
  InputAdornment
} from "@mui/material";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Card, Stack, Link, Container, Typography } from "@mui/material";
// layouts
// components
import Page from "../components/Page";
import { MHidden } from "../components/@material-extend";
import Logo from "../components/Logo";
import { LoginForm } from "../components/authentication/login";
import AuthSocial from "../components/authentication/AuthSocial";
import moment from "moment";
import {
  CheckMobileNumberExist,
  InsertPublicLeadMemberForm,
  insertLead,
  sendOtpToMobile,
  updateLeadMemberForm,
  validatecityformlink,
  verifyGSTNumber
} from "src/api/commonapi";
import { fetchGstDetailsbynumberApi } from "src/api/invoiceApi";
import { notification } from "src/utils/messages";
import { Routes } from "../constant/api_url";
import { getLeadDetailsUsingId } from "src/utils/common";
import { DatePicker, LocalizationProvider } from "@mui/lab";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Label from "src/components/Label";
import { AddPhotoAlternate, Business, LocalPhone, Person } from "@mui/icons-material";
import { decryptMyData, gender } from "src/constant/variable";

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up("md")]: {
    display: "flex"
  }
}));

const warningModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  boxShadow: 10,
  borderRadius: "10px",
  p: 4
};

const SectionStyle = styled(Card)(({ theme }) => ({
  width: "100%",
  maxWidth: 464,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  margin: theme.spacing(2, 0, 2, 2)
}));

const ContentStyle = styled("div")(({ theme }) => ({
  maxWidth: 720,
  margin: "auto",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: "30px 0"
}));

const LoginFormCard = {
  padding: "15px",
  margin: "auto",
  display: "block",
  width: "100%"
};
const Login_body = {
  margin: "15px"
};
const form_title = {
  margin: "15px 0",
  textAlign: "center"
};

const allowedFileTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
];

const allowFileImageTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif"
];

const genderOptions = gender.filter((g) => g.value !== 0);

// ----------------------------------------------------------------------

export default React.memo(function LeadForm() {
  let { c_id, cityname } = useParams();
  const navigate = useNavigate();

  const City_amb_id = useMemo(() => c_id != undefined ? Buffer.from(c_id, "base64").toString("ascii") : 1, [c_id]);
  const p_u_id = useMemo(() => c_id != undefined ? 1 : 0, [c_id]);
  const date = useMemo(() => moment().format("DD-MM-YYYY"), []);

  useEffect(() => {
    const checkCityLink = async () => {
      const response = await validatecityformlink({
        form_url: window.location.pathname
      });
      if (response.status == 0) {
        navigate("/404");
      }
    }
    checkCityLink();
  }, []);

  const [formData, setFormData] = useState({
    // Mail Id
    lead_id: "",
    l_created_by: City_amb_id,
    l_allocated_to: City_amb_id,
    p_u_id: p_u_id,
    l_type: 3,
    l_phase: 4,
    date: date,
    c_f: true,
    from_l_phase: "",

    // Step 1
    gender: 0,
    first_name: "",
    last_name: "",
    dob: "",
    l_contact_no: "",
    alternate_contact_number: "",
    insuranceType: [],
    otherInsurance: "",
    aadhaar: "",
    facebook_url: "",
    instagram_url: "",

    // Step 2
    l_business_name: "",

    l_business_category: "",
    l_business_description: "",
    pr_gst_verify: "0",
    gst_no: "",
    gst_business_name: "",
    gst_business_address: "",
    l_email: "",
    l_address: "", // office address
    l_h_address: "", // home address
    payment_date: "",
    payment_mode: 0,
    l_professional_photo: "",
    // l_product_photo: "",
    l_payment_photo: [],
    l_reference_1: "",
    l_reference_2: "",

    //
    updateby_member: 0,
    verify_otp: "",
    is_edit_form: 0
  });
  const [activeTab, setActiveTab] = useState(3);
  const [otpSent, setOtpSent] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isMember, setIsMember] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [anotherCityMemberModal, setAnotherCityMemberModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [originalGstBusinessName, setOriginalGstBusinessName] = useState("");

  const handleInsuranceCheckBoxEvent = (e) => {
    const value = e.target.value;
    const isChecked = e.target.checked;

    if (isChecked) {
      // If checkbox is checked, add the value to the array
      const updatedInsuranceType = [...formData.insuranceType, value];
      setFormData({
        ...formData,
        insuranceType: updatedInsuranceType
      });
    } else {
      // If checkbox is unchecked, remove the value from the array
      const updatedInsuranceType = formData.insuranceType.filter((item) => item !== value);
      setFormData({
        ...formData,
        insuranceType: updatedInsuranceType
      });
    }
  };

  const [errors, setErrors] = useState({
    gender: "",
    first_name: "",
    last_name: "",
    dob: "",
    l_contact_no: "",
    alternate_contact_number: "",
    insuranceType: "",
    aadhaar: "",
    facebook_url: "",
    instagram_url: "",
    gst_no: "",
    l_business_name: "",
    l_business_category: "",
    l_email: "",
    l_address: "",
    l_h_address: "",
    payment_date: "",
    payment_mode: "",
    l_professional_photo: "",
    l_payment_photo: "",
    l_reference_1: "",
    l_reference_2: ""
  });

  const submitFormData = async () => {
    let firstStepValidationCheck = checkValidation(1);

    if (!firstStepValidationCheck) {
      let notify = notification({
        type: "error",
        message: "Please Fill All Required Fields"
      });
      notify();
    } else {
      setIsLoading(true);

      const checkRes = await CheckMobileNumberExist({
        mobile: formData.l_contact_no,
        l_allocated_to: City_amb_id
      });

      if (checkRes?.data?.show_popup === 1) {
        setRowData(checkRes?.data);
        setAnotherCityMemberModal(true);
        setIsLoading(false);
        return;
      }

      if (checkRes?.data && checkRes?.data?.l_phase === 6) {
        setRowData(checkRes?.data);
        setWarningModal(true);
        setIsLoading(false);
        return;
      }

      if (checkRes.status == 2) {
        setIsMember(true);
        setIsLoading(false);
        return;
      }

      let fndata = new FormData();

      for (const key in formData) {
        if (key === "insuranceType") {
          const insurance = Array.isArray(formData[key]) ? formData[key].join(",") : formData[key];
          fndata.append(key, insurance);
        } else if (key === "gst_no") {
          // ✅ only append gst_no if pr_gst_verify === 1, else blank
          fndata.append("gst_no", formData.pr_gst_verify == 1 ? formData.gst_no : "");
        } else if (key === "gst_business_name") {
          fndata.append("gst_business_name", formData.pr_gst_verify == 1 ? formData.gst_business_name : "");
        } else if (key === "gst_business_address") {
          fndata.append("gst_business_address", formData.pr_gst_verify == 1 ? formData.gst_business_address : "");
        } else if (key === "l_payment_photo") {
          // Append multiple payment photos
          if (Array.isArray(formData[key]) && formData[key].length > 0) {
            formData[key].forEach((file, index) => {
              fndata.append(`l_payment_photo`, file);
            });
          }
        } else {
          fndata.append(key, formData[key]);
        }
      }

      // Force l_phase to 3 for update API
      fndata.set("l_phase", 4);

      // Only add edit_from_city_form when accessed through public URL (p_u_id = 1)
      if (p_u_id === 1) {
        fndata.append("edit_from_city_form", 1);
      }

      if (formData.lead_id != "") {
        let resp = await updateLeadMemberForm(fndata);

        setIsLoading(false);

        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        if (resp.status == 1) {
          setFormData({
            // Mail Id
            lead_id: "",
            l_created_by: City_amb_id,
            l_allocated_to: City_amb_id,
            p_u_id: p_u_id,
            l_type: 3,
            l_phase: 4,
            date: date,
            c_f: true,
            from_l_phase: 0,

            // Step 1
            gender: 0,
            first_name: "",
            last_name: "",
            dob: "",
            l_contact_no: "",
            alternate_contact_number: "",
            insuranceType: [],
            otherInsurance: "",
            aadhaar: "",
            facebook_url: "",
            instagram_url: "",

            // Step 2
            l_business_name: "",
            l_business_category: "",
            l_business_description: "",
            pr_gst_verify: "0",
            gst_no: "",
            gst_business_name: "",
            gst_business_address: "",
            l_email: "",
            l_address: "", // office address
            l_h_address: "", // home address
            payment_date: "",
            payment_mode: 0,
            l_professional_photo: "",
            // l_product_photo: "",
            l_payment_photo: [],
            l_reference_1: "",
            l_reference_2: "",

            //
            updateby_member: 0
          });
          setOriginalGstBusinessName("");
          setIsLoading(false);
          setRowData(resp?.data);
          setActiveTab(3); // Reset to mobile verification tab
          setOtpSent(false); // Reset OTP sent state
          setSuccessModal(true);
        } else {
          setIsLoading(false);
        }
      } else {
        let resp = await InsertPublicLeadMemberForm(fndata);

        let notify = notification({
          type: resp.status == 0 ? "error" : "success",
          message: resp.message
        });
        notify();
        if (resp.status == 1) {
          setFormData({
            // Mail Id
            lead_id: "",
            l_created_by: City_amb_id,
            l_allocated_to: City_amb_id,
            p_u_id: p_u_id,
            l_type: 3,
            l_phase: 4,
            date: date,
            c_f: true,

            // Step 1
            gender: 0,
            first_name: "",
            last_name: "",
            dob: "",
            l_contact_no: "",
            alternate_contact_number: "",
            insuranceType: [],
            otherInsurance: "",
            aadhaar: "",
            facebook_url: "",
            instagram_url: "",

            // Step 2
            l_business_name: "",
            l_business_category: "",
            l_business_description: "",
            pr_gst_verify: "0",
            gst_no: "",
            gst_business_name: "",
            gst_business_address: "",
            l_email: "",
            l_address: "", // office address
            l_h_address: "", // home address
            payment_date: "",
            payment_mode: 0,
            l_professional_photo: "",
            // l_product_photo: "",
            l_payment_photo: [],
            l_reference_1: "",
            l_reference_2: "",

            //
            updateby_member: 0
          });
          setOriginalGstBusinessName("");
          setIsLoading(false);
          setActiveTab(3); // Reset to mobile verification tab
          setOtpSent(false); // Reset OTP sent state
        }
      }
    }
  };

  const onChangeFunction = useCallback((e) => {
    const { name, value } = e.target;

    if (name === "pr_gst_verify" && value != "1") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        gst_no: "",
        gst_business_name: "",
        gst_business_address: ""
      }));
      setOriginalGstBusinessName("");
      setErrors((prev) => ({
        ...prev,
        gst_no: ""
      }));
    } else if (name === "gst_no") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        gst_business_name: "",
        gst_business_address: ""
      }));
      setOriginalGstBusinessName("");
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    if (name === "verify_otp") setOtpError("");
  }, []);

  const validateGST = (value) => {
    if (!value || value.trim() === "") {
      return "GST number is required";
    }

    const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/;

    if (!gstRegex.test(value)) {
      return "Enter valid GST number";
    }

    return "";
  };

  const fetchGstDetailsbynumber = async (gst_no) => {
    const gstError = validateGST(gst_no);
    if (gstError) {
      notification({
        type: "error",
        message: gstError
      })();
      setErrors((prev) => ({
        ...prev,
        gst_no: gstError
      }));
      return;
    }
    if (!gst_no || gst_no.trim() === "") {
      notification({
        type: "error",
        message: "Please enter a valid GST number."
      })();
      return;
    }
    try {
      const response = await fetchGstDetailsbynumberApi({ gst_no: gst_no });

      if (response.status === 1) {
        const busName = response.data?.business_name || "";
        setFormData((prev) => ({
          ...prev,
          gst_business_name: busName,
          gst_business_address: response.data?.address || ""
        }));
        setOriginalGstBusinessName(busName);
        notification({
          type: "success",
          message: response.message
        })();
        setErrors((prev) => ({
          ...prev,
          gst_no: ""
        }));
      } else {
        notification({
          type: "error",
          message: response.message || "Invalid GST Number"
        })();
      }
    } catch (error) {
      notification({
        type: "error",
        message: "Failed to fetch GST details"
      })();
    }
  };

  const sendOtpToMobileNumber = async () => {
    if (!formData.l_contact_no || !/^[0-9]{10}$/.test(formData.l_contact_no)) {
      setErrors((prev) => ({
        ...prev,
        l_contact_no: "Enter Only 10 digits allowed. Do not add +91 or characters."
      }));
      return;
    }

    setErrors((prev) => ({
      ...prev,
      l_contact_no: ""
    }));

    const response = await sendOtpToMobile({ mobile: formData.l_contact_no });

    if (response.status === 1 && response.otp) {
      const otpData = decryptMyData(response.otp);
      localStorage.setItem("customer_otp", otpData.code); // Store OTP
      setOtpSent(true);
      setOtpError("");

      notification({
        type: "success",
        message: response.message || "OTP sent successfully. Please check your mobile."
      })();
    } else {
      notification({
        type: "error",
        message: response.message
      })();
    }
  };

  const verifyOtp = async () => {
    if (!formData.verify_otp || formData.verify_otp.length !== 6) {
      setOtpError("Enter a valid 6-digit OTP.");
      return;
    }

    const localOtp = localStorage.getItem("customer_otp");

    if (formData.verify_otp === localOtp) {
      // Clear error and move forward
      setOtpError("");
      notification({
        type: "success",
        message: "Your OTP has been verified. Proceeding to the next step."
      })();

      setFormData((prev) => ({ ...prev, otp_verified: true }));

      // Check mobile existence
      const response = await CheckMobileNumberExist({
        mobile: formData.l_contact_no,
        l_allocated_to: City_amb_id
      });

      if (response?.data?.show_popup === 1) {
        setRowData(response?.data);
        setAnotherCityMemberModal(true);
      }

      if (response?.data && response?.data?.l_phase === 6) {
        setRowData(response?.data);
        setWarningModal(true);
      }

      if (response.status == 2) {
        setIsMember(true);
      } else if (response.status === 3) {
        // Update form with existing data
        setFormData({
          ...formData,
          otp_verified: true,
          type: response.data?.type || 0,
          m_id: response.data?.m_id || "",
          status: response.data?.status || "",
          from_l_phase: response.data?.l_phase,

          // Step 1
          gender: response.data?.gender || 0,
          first_name: response.data?.first_name || response.data?.m_name || "",
          last_name: response.data?.last_name || "",
          dob: response.data?.dob || "",
          l_contact_no: response.data?.mobile_no || "",
          // facebook_url: response.data?.fb || "",
          // instagram_url: response.data?.instagram || "",

          // Step 2
          l_business_name: response.data?.business_name || "",
          l_business_category: response.data?.business_category || "",
          gst_no: response.data?.pr_gstno || "",
          gst_business_name: response.data?.gst_business_name || "",
          gst_business_address: response.data?.gst_business_address || "",
          l_email: response.data?.m_email_id || ""
          // l_address: response.data?.pr_m_address || "",
          // l_h_address: response.data?.b_address || ""
        });
        setOriginalGstBusinessName(response.data?.gst_business_name || "");
        setIsMember(false);
      } else if (response.status === 1) {
        // Update form with existing data
        setFormData({
          ...formData,
          otp_verified: true,
          lead_id: response.data?.lead_id || "", // Ensure lead_id is set
          l_phase: response.data?.l_phase || 4,
          status: response.data?.status,
          from_l_phase: response.data?.l_phase,

          // Step 1

          gender: response.data?.gender || 0,
          first_name: response.data?.first_name || response.data?.name || "",
          last_name: response.data?.last_name || "",
          dob: response.data?.dob || "",
          l_contact_no: response.data?.l_contact_no || "",
          alternate_contact_number: response.data?.alternate_contact_number || "",
          insuranceType: response.data?.insuranceType,
          otherInsurance: response.data?.otherInsurance || "",
          aadhaar: response.data?.aadhaar || "",
          // facebook_url: response.data?.facebook_url || "",
          // instagram_url: response.data?.instagram_url || "",

          // Step 2
          l_business_name: response.data?.l_business_name || "",
          l_business_category: response.data?.l_business_category || "",
          l_business_description: response.data?.l_business_description || "",
          gst_no: response.data?.gst_no || "",
          gst_business_name: response.data?.gst_business_name || "",
          gst_business_address: response.data?.gst_business_address || "",
          pr_gst_verify: response.data?.gst_no ? "1" : "0",
          l_email: response.data?.l_email || "",
          // l_address: response.data?.l_address || "",
          // l_h_address: response.data?.l_h_address || "",
          payment_date: response.data?.payment_date || "",
          payment_mode: response.data?.payment_mode || 0,
          l_professional_photo: response.data?.l_professional_photo || "",
          // l_product_photo: response.data?.l_product_photo || "",
          l_payment_photo: response.data?.l_payment_photo || "",
          l_reference_1: response.data?.l_reference_1 || "",
          l_reference_2: response.data?.l_reference_2 || "",
          updateby_member: response.data?.updateby_member || 0,
          is_edit_form: response.data?.is_edit_form || 0
        });
        setOriginalGstBusinessName(response.data?.gst_business_name || "");
        setIsMember(false);
      } else {
        setIsMember(false);
        // New user — allow form filling
        submitFormData();
      }
      setActiveTab(1);
      localStorage.removeItem("customer_otp");
    } else {
      setOtpError("Incorrect OTP. Please try again.");
    }
  };

  const checkValidation = (active = undefined) => {
    const newErrors = { ...errors };
    const currentTab = active != undefined ? active : activeTab;

    if (currentTab == 3) {
      // Contact Number validation
      if (
        formData.l_contact_no == undefined ||
        formData.l_contact_no == "" ||
        formData.l_contact_no.trim() === ""
      ) {
        newErrors.l_contact_no = "Contact Number is required.";
      } else if (!/^[0-9]{10}$/.test(formData.l_contact_no)) {
        newErrors.l_contact_no = "Enter a valid Contact Number.";
      } else {
        newErrors.l_contact_no = "";
      }

      setErrors(newErrors);

      const isValid = Object.values(newErrors).every((error) => error === "");

      // Only allow going to next step if valid
      if (isValid) {
        setActiveTab(2); // allow moving to Business Details only if valid
      } else {
        setActiveTab(1); // stay on Personal Details if errors exist
      }

      return isValid;
    } else if (currentTab == 1) {
      // validation for 1st section
      // Validate First Name
      if (formData.first_name == undefined || formData.first_name == "" || formData.first_name.trim() === "") {
        newErrors.first_name = "First name is required.";
      } else {
        newErrors.first_name = "";
      }

      // Validate Last Name
      if (formData.last_name == undefined || formData.last_name == "" || formData.last_name.trim() === "") {
        newErrors.last_name = "Last name is required.";
      } else {
        newErrors.last_name = "";
      }

      if (formData.aadhaar == undefined || formData.aadhaar == "") {
        newErrors.aadhaar = "Aadhaar Image is required.";
      } else {
        newErrors.aadhaar = "";
      }

      setErrors(newErrors);

      // Business Name
      if (formData.l_business_name == undefined || formData.l_business_name.trim() === "") {
        newErrors.l_business_name = "Business Name is required.";
      } else {
        newErrors.l_business_name = "";
      }

      // Business Category
      if (formData.l_business_category == undefined || formData.l_business_category.trim() === "") {
        newErrors.l_business_category = "Business Category is required.";
      } else {
        newErrors.l_business_category = "";
      }
      // Business Category
      if (
        (formData.gst_no == undefined || formData.gst_no.trim() === "") &&
        formData.pr_gst_verify == 1
      ) {
        newErrors.gst_no = "GST No is required.";
      } else {
        newErrors.gst_no = "";
      }

      // GST validation - FIXED: Only validate GST if pr_gst_verify is 1
      if (formData.pr_gst_verify == 1) {
        newErrors.gst_no = validateGST(formData.gst_no);
      } else {
        newErrors.gst_no = ""; // clear error if GST not required
      }

      // Email validations
      if (formData.l_email == undefined || formData.l_email.trim() === "") {
        newErrors.l_email = "Email is required.";
      } else {
        if (!/^\S+@\S+\.\S+$/.test(formData.l_email)) {
          newErrors.l_email = "Please enter Valid Mail.";
        } else {
          newErrors.l_email = "";
        }
      }

      // Payment Date
      if (formData.payment_date == undefined || formData.payment_date == "") {
        newErrors.payment_date = "Payment Date is required.";
      } else {
        newErrors.payment_date = "";
      }

      // Professional Photo
      if (formData.l_professional_photo == undefined || formData.l_professional_photo == "") {
        newErrors.l_professional_photo = "Professional Image is required.";
      } else {
        newErrors.l_professional_photo = "";
      }

      // Payment Photo
      if (formData.l_payment_photo == undefined || formData.l_payment_photo.length === 0) {
        newErrors.l_payment_photo = "Payment Image is required.";
      } else {
        newErrors.l_payment_photo = "";
      }

      // Reference 1
      if (formData.l_reference_1 == undefined || formData.l_reference_1.trim() === "") {
        newErrors.l_reference_1 = "Reference is required.";
      } else {
        newErrors.l_reference_1 = "";
      }

      // Reference 2
      if (formData.l_reference_2 == undefined || formData.l_reference_2.trim() === "") {
        newErrors.l_reference_2 = "Reference is required.";
      } else {
        newErrors.l_reference_2 = "";
      }

      // Gender
      if (formData.gender == undefined || formData.gender == 0 || formData.gender == "") {
        newErrors.gender = "Gender is required.";
      } else {
        newErrors.gender = "";
      }

      setErrors(newErrors);

      const isValid = Object.values(newErrors).every((error) => error === "");

      // FIXED: Don't change tab for step 2 validation
      // Stay on Business Details tab (tab 2) if validation fails
      // The tab change should only happen when user explicitly clicks Next/Submit

      return isValid;
    }

  };

  const handleFileChange = (event, inputName) => {
    const files = inputName === "l_payment_photo" ? event.target.files : [event.target.files[0]];

    if (inputName === "l_payment_photo") {
      // Handle multiple files for payment photo
      const validFiles = [];
      const invalidFiles = [];

      Array.from(files).forEach((file) => {
        if (allowedFileTypes.includes(file.type)) {
          validFiles.push(file);
        } else {
          invalidFiles.push(file.name);
        }
      });

      if (invalidFiles.length > 0) {
        setErrors({
          ...errors,
          [inputName]: `Invalid file type for: ${invalidFiles.join(", ")}. Upload File Must be an Image`
        });
      } else {
        const existingFiles = Array.isArray(formData[inputName]) ? formData[inputName] : [];
        // Filter out duplicates
        const newFiles = validFiles.filter((newFile) => {
          return !existingFiles.some(
            (existingFile) =>
              existingFile.name === newFile.name && existingFile.size === newFile.size
          );
        });

        // If file already exists, replace it
        const updatedFiles = existingFiles.map((existingFile) => {
          const replacement = validFiles.find(
            (newFile) => newFile.name === existingFile.name && newFile.size === existingFile.size
          );
          return replacement || existingFile;
        });

        // Add completely new files
        const finalFiles = [...updatedFiles, ...newFiles];
        setFormData({ ...formData, [inputName]: finalFiles });
        setErrors({ ...errors, [inputName]: "" });
      }
    } else {
      const file = files[0];
      if (file) {
        if ((inputName == "aadhaar" ? allowedFileTypes : allowFileImageTypes).includes(file.type)) {
          setFormData({ ...formData, [inputName]: file });
          setErrors({ ...errors, [inputName]: "" });
        } else {
          setErrors({
            ...errors,
            [inputName]: `${inputName == "aadhaar"
              ? "Upload File Must Be PDF, Image or Doc"
              : "Upload File Must be an Image"
              }`
          });
        }
      }
    }
  };

  return (
    <>
      <Page title="Inquiry Form | Local Vocal Business Group">
        <Container>
          <ContentStyle style={{ alignItems: "center", padding: "0", maxWidth: "780px" }}>
            {isMember === true ? (
              <Box
                sx={{
                  minHeight: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Card
                  sx={{
                    maxWidth: 600,
                    p: 4,
                    boxShadow:
                      "0px 3px 3px 3px rgba(145, 158, 171, 0.2), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)",
                    borderRadius: 3,
                    backgroundColor: "#fefefe"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center"
                    }}
                  >
                    <Box
                      component="img"
                      // src={Routes.API_HOSTNAME + "logo/LVB-Logo.png"}
                      src={Routes.API_HOSTNAME + "logo/LVB-PRIVILEGE-LOGO.png"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/static/logo/LVB-PRIVILEGE-LOGO.png";
                      }}
                      alt="LVB Logo"
                      sx={{ height: 80, mb: 2 }}
                    />
                    <Avatar
                      sx={{
                        bgcolor: "primary.main",
                        width: 56,
                        height: 56,
                        mb: 2,
                        mt: 3
                      }}
                    >
                      <Person sx={{ fontSize: 32 }} />
                    </Avatar>
                    <Typography variant="h5" gutterBottom color="primary">
                      You're already a member!
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
                      Thank you for your interest. Our records show that you’ve already completed
                      the membership process.
                    </Typography>
                  </Box>
                </Card>
              </Box>
            ) : warningModal === true ? (
              <Box
                sx={{
                  minHeight: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Card
                  sx={{
                    maxWidth: 600,
                    p: 4,
                    boxShadow:
                      "0px 0px 20px 15px rgb(86 86 86 / 20%), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)",
                    borderRadius: 3,
                    backgroundColor: "#fefefe"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center"
                    }}
                  >
                    <Box
                      component="img"
                      // src={Routes.API_HOSTNAME + "logo/LVB-Logo.png"}
                      src={Routes.API_HOSTNAME + "logo/LVB-PRIVILEGE-LOGO.png"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/static/logo/LVB-PRIVILEGE-LOGO.png";
                      }}
                      alt="LVB Logo"
                      sx={{ height: 80, mb: 2 }}
                    />
                    <Avatar
                      sx={{
                        bgcolor: "primary.main",
                        width: 56,
                        height: 56,
                        mb: 2,
                        mt: 3
                      }}
                    >
                      <Person sx={{ fontSize: 32 }} />
                    </Avatar>
                    <Typography variant="h5" gutterBottom color="primary">
                      {rowData.disable_message_title}
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, mb: 2, whiteSpace: "pre-line" }}>
                      <span dangerouslySetInnerHTML={{ __html: rowData?.disable_message ?? "" }} />
                    </Typography>
                  </Box>
                </Card>
              </Box>
            ) : anotherCityMemberModal === true ? (
              <Box
                sx={{
                  minHeight: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Card
                  sx={{
                    maxWidth: 600,
                    p: 4,
                    boxShadow:
                      "0px 0px 20px 15px rgb(86 86 86 / 20%), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)",
                    borderRadius: 3,
                    backgroundColor: "#fefefe"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center"
                    }}
                  >
                    <Box
                      component="img"
                      // src={Routes.API_HOSTNAME + "logo/LVB-Logo.png"}
                      src={Routes.API_HOSTNAME + "logo/LVB-PRIVILEGE-LOGO.png"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/static/logo/LVB-PRIVILEGE-LOGO.png";
                      }}
                      alt="LVB Logo"
                      sx={{ height: 80, mb: 2 }}
                    />
                    <Avatar
                      sx={{
                        bgcolor: "primary.main",
                        width: 56,
                        height: 56,
                        mb: 2,
                        mt: 3
                      }}
                    >
                      <Person sx={{ fontSize: 32 }} />
                    </Avatar>
                    <Typography variant="h5" gutterBottom color="primary">
                      {rowData.disable_message_title}
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, mb: 2, whiteSpace: "pre-line" }}>
                      <span dangerouslySetInnerHTML={{ __html: rowData?.disable_message ?? "" }} />
                    </Typography>
                  </Box>
                </Card>
              </Box>
            ) : successModal === true ? (
              <Box
                sx={{
                  minHeight: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Card
                  sx={{
                    maxWidth: 600,
                    p: 4,
                    boxShadow:
                      "0px 0px 20px 15px rgb(86 86 86 / 20%), 0px 3px 4px 0px rgba(145, 158, 171, 0.14), 0px 1px 8px 0px rgba(145, 158, 171, 0.12)",
                    borderRadius: 3,
                    backgroundColor: "#fefefe"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center"
                    }}
                  >
                    <Box
                      component="img"
                      // src={Routes.API_HOSTNAME + "logo/LVB-Logo.png"}
                      src={Routes.API_HOSTNAME + "logo/LVB-PRIVILEGE-LOGO.png"}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "/static/logo/LVB-PRIVILEGE-LOGO.png";
                      }}
                      alt="LVB Logo"
                      sx={{ height: 80, mb: 2 }}
                    />
                    <Avatar
                      sx={{
                        bgcolor: "primary.main",
                        width: 56,
                        height: 56,
                        mb: 2,
                        mt: 3
                      }}
                    >
                      <Person sx={{ fontSize: 32 }} />
                    </Avatar>

                    <Typography variant="h5" gutterBottom color="primary">
                      {rowData?.title}
                    </Typography>
                    <Typography variant="body1" sx={{ mt: 1, mb: 2 }}>
                      {rowData?.message}
                    </Typography>
                  </Box>
                </Card>
              </Box>
            ) : (
              <Box
                sx={{
                  minHeight: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: "100%"
                }}
              >
                <Card className="LoginFormCard" style={LoginFormCard}>
                  <Box
                    component="img"
                    // src="/static/logolvb.png"
                    // src={Routes.API_HOSTNAME + "logo/LVB-Logo.png"}
                    src={Routes.API_HOSTNAME + "logo/LVB-PRIVILEGE-LOGO.png"}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/static/logo/LVB-PRIVILEGE-LOGO.png";
                    }}
                    sx={{ display: "block", margin: "auto", height: "100px" }}
                  />
                  <h4 className="form_title" style={form_title}>
                    Fill Your Details
                  </h4>

                  <div className="Login_body" style={Login_body}>
                    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                      <Tabs
                        value={activeTab}
                        variant="fullWidth"
                        allowScrollButtonsMobile
                        // onChange={() => {}}
                        // onChange={
                        //   (e, value) => {
                        //     // checkValidation(value);
                        //     setActiveTab(value);
                        //   }
                        //   // setMemberDetailData([]),
                        //   // setActiveTab(value),
                        //   // getMembersDetailReport(value, activeRow.m_id)
                        // }
                        onChange={(e, value) => {
                          // Prevent changing tab unless allowed
                          if (value === 1 && !formData?.otp_verified) return; // Personal locked until OTP
                          setActiveTab(value);
                        }}
                      >
                        <Tab
                          style={{ marginBottom: "0", paddingBottom: "0", cursor: "auto" }}
                          disableRipple
                          key={3}
                          value={3}
                          label="Mobile Number Verify"
                          icon={<LocalPhone />}
                          iconPosition="start"
                          disabled={formData?.otp_verified}
                        />
                        <Tab
                          style={{ marginBottom: "0", paddingBottom: "0", cursor: "auto" }}
                          disableRipple
                          key={1}
                          value={1}
                          label="Personal / Business Details"
                          icon={<Person />}
                          iconPosition="start"
                          disabled={!formData?.otp_verified}
                        />
                        {/* <Tab
                          style={{ marginBottom: "0", paddingBottom: "0", cursor: "auto" }}
                          disableRipple
                          key={2}
                          value={2}
                          label="Business Details"
                          icon={<Business />}
                          iconPosition="start"
                          disabled={!formData?.otp_verified}
                        /> */}
                      </Tabs>
                    </Box>
                    {activeTab === 1 && (
                      <span style={{ fontSize: "12px", color: "red", display: "block", marginTop: "10px", textAlign: "center" }}>
                        <b>Note:</b> Please enter only your <b>First Name and Last Name (Surname).</b> Skip your Middle Name.<br />
                        <b>Example:</b> Akash Kanubhai Vaghasiya → First Name: <b>Akash</b> | Last Name: <b>Vaghasiya</b>
                      </span>
                    )}
                    <Grid
                      container
                      spacing={1.5}
                      style={{ marginTop: "15px" }}
                      alignItems="stretch"
                    >
                      {activeTab == 3 ? (
                        <>
                          <Grid
                            container
                            spacing={1.5}
                            style={{ marginTop: "15px", justifyContent: "center" }}
                          >
                            <Grid item xs={12} md={8}>
                              <Stack spacing={2} style={{ marginBottom: "7px" }}>
                                <TextField
                                  fullWidth
                                  required
                                  label="Contact Number"
                                  name="l_contact_no"
                                  inputProps={{ maxLength: 10 }}
                                  margin="dense"
                                  disabled={otpSent}
                                  value={formData?.l_contact_no}
                                  onChange={(e) => {
                                    // Remove all spaces from the input
                                    const value = e.target.value.replace(/\s+/g, "");

                                    onChangeFunction({
                                      target: {
                                        name: "l_contact_no",
                                        value: value
                                      }
                                    });
                                  }}
                                  error={!!errors.l_contact_no}
                                  helperText={errors.l_contact_no}
                                />
                                <span
                                  style={{ fontSize: "13px", color: "orange", marginTop: "3px" }}
                                >
                                  Only 10 digits allowed. Do not add +91 or characters or blank
                                  space.
                                </span>

                                {!otpSent && (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={formData?.acceptTerms || false}
                                        onChange={(e) =>
                                          onChangeFunction({
                                            target: {
                                              name: "acceptTerms",
                                              value: e.target.checked
                                            }
                                          })
                                        }
                                      />
                                    }
                                    label={
                                      <span>
                                        I accept the{" "}
                                        <a
                                          href="https://lvb-india.com/privilege-terms-conditions"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ color: "#034766" }}
                                        >
                                          <b>Terms & Conditions</b>
                                        </a>{" "}
                                        and the{" "}
                                        <a
                                          href="https://lvb-india.com/privilege-privacy-policy"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ color: "#034766" }}
                                        >
                                          <b>LVB Privacy Policy</b>
                                        </a>
                                        .
                                      </span>
                                    }
                                  />
                                )}
                              </Stack>
                            </Grid>

                            {otpSent && (
                              <Grid item xs={12} md={8}>
                                <Stack spacing={2} style={{ marginBottom: "15px" }}>
                                  <TextField
                                    fullWidth
                                    required
                                    label="Enter OTP"
                                    name="verify_otp"
                                    value={formData.verify_otp || ""}
                                    onChange={onChangeFunction}
                                    helperText={otpError}
                                    error={otpError !== ""}
                                    type="tel"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    InputProps={{
                                      inputProps: {
                                        maxLength: 6,
                                        inputMode: "numeric",
                                        pattern: "[0-9]*"
                                      }
                                    }}
                                    onKeyPress={(e) => {
                                      if (!/[0-9]/.test(e.key)) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={formData?.acceptTerms || false}
                                        disabled={otpSent}
                                        onChange={(e) =>
                                          onChangeFunction({
                                            target: {
                                              name: "acceptTerms",
                                              value: e.target.checked
                                            }
                                          })
                                        }
                                      />
                                    }
                                    label={
                                      <span>
                                        I accept the{" "}
                                        <a
                                          href="https://lvb-india.com/privilege-terms-conditions"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ color: "#034766" }}
                                        >
                                          <b>Terms & Conditions</b>
                                        </a>{" "}
                                        and the{" "}
                                        <a
                                          href="https://lvb-india.com/privilege-privacy-policy"
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          style={{ color: "#034766" }}
                                        >
                                          <b>LVB Privacy Policy</b>
                                        </a>
                                        .
                                      </span>
                                    }
                                  />
                                </Stack>
                              </Grid>
                            )}
                            <Grid item xs={12} md={8}>
                              <Stack spacing={2} style={{ marginBottom: "15px" }}>
                                {otpSent ? (
                                  <Button variant="contained" onClick={verifyOtp}>
                                    Verify OTP
                                  </Button>
                                ) : (
                                  <Button
                                    variant="contained"
                                    onClick={async (e) => {
                                      sendOtpToMobileNumber();
                                    }}
                                    disabled={
                                      !formData.l_contact_no || // no number
                                      !/^[0-9]{10}$/.test(formData.l_contact_no) || // invalid number
                                      !formData.acceptTerms // terms not accepted
                                    }
                                  >
                                    Send OTP
                                  </Button>
                                )}
                              </Stack>
                            </Grid>
                          </Grid>
                        </>
                      ) : activeTab == 1 ? (
                        <>
                          <Grid container spacing={1.5} style={{ marginTop: "15px" }}>
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <FormControl component="fieldset">
                                  <FormLabel component="legend">Gender</FormLabel>

                                  <RadioGroup
                                    name="gender"
                                    row // remove this if you want vertical
                                    value={formData?.gender || 0}
                                    onChange={onChangeFunction}
                                  >
                                    {genderOptions.map((g) => (
                                        <FormControlLabel
                                          key={g.value}
                                          value={g.value}
                                          control={<Radio />}
                                          label={g.label}
                                        />
                                      ))}
                                  </RadioGroup>
                                </FormControl>
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  required
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 1 ||
                                      formData?.l_phase === 8 ||
                                      formData?.l_phase === 4 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                  autoComplete="off"
                                  type="text"
                                  label="First Name"
                                  name="first_name"
                                  value={formData?.first_name}
                                  onChange={onChangeFunction}
                                  autoCorrect="off"
                                  helperText={errors.first_name}
                                  error={errors.first_name != "" ? true : false}
                                  onBlur={(e) => errors.first_name != "" && checkValidation()}
                                />
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={3}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  required
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 1 ||
                                      formData?.l_phase === 8 ||
                                      formData?.l_phase === 4 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                  autoComplete="off"
                                  type="text"
                                  label="Last Name"
                                  name="last_name"
                                  value={formData?.last_name}
                                  onChange={onChangeFunction}
                                  autoCorrect="off"
                                  helperText={errors.last_name}
                                  error={errors.last_name != "" ? true : false}
                                  onBlur={(e) => errors.last_name != "" && checkValidation()}
                                />
                              </Stack>
                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDateFns}
                                  style={{ marginTop: "15px", background: "yellow" }}
                                >
                                  <DatePicker
                                    disabled={
                                      !(
                                        formData?.status === 0 ||
                                        formData?.l_phase === 0 ||
                                        formData?.l_phase === 7 ||
                                        formData?.l_phase === 3 ||
                                        (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                      ) &&
                                      formData?.type !== 6 &&
                                      true
                                    }
                                    type="date"
                                    name="dob"
                                    label="Date of Birth"
                                    value={
                                      formData?.dob != undefined
                                        ? moment(formData.dob, "DD-MM-YYYY")
                                        : null
                                    }
                                    disableFuture
                                    inputFormat="dd/MM/yyyy"
                                    onChange={(newDate) => {
                                      setFormData({
                                        ...formData,
                                        dob: moment(newDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                                      });
                                    }}
                                    onBlur={() => errors.dob != "" && checkValidation()}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        helperText={errors.dob}
                                        onBlur={() => errors.dob != "" && checkValidation()}
                                        error={errors.dob != "" ? true : false}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              </Stack>
                            </Grid> */}
                            {/* <Grid item xs={12} md={6}>
                      <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        <TextField
                          style={{ marginTop: "0px" }}
                          fullWidth
                          required
                          autoComplete="off"
                          type="text"
                          label="Contact Number"
                          name="l_contact_no"
                          value={formData?.l_contact_no}
                          onChange={onChangeFunction}
                          autoCorrect="off"
                          helperText={errors.l_contact_no}
                          error={errors.l_contact_no != "" ? true : false}
                          onBlur={() => errors.l_contact_no != "" && checkValidation()}
                          disabled={formData?.updateby_member == 1 && true}
                        />
                        // <ErrorDisplay msg={errors.l_contact_no} />
                      </Stack>
                    </Grid> */}
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  autoComplete="off"
                                  type="text"
                                  required
                                  label="Company Name"
                                  name="l_business_name"
                                  value={formData?.l_business_name}
                                  onChange={onChangeFunction}
                                  autoCorrect="off"
                                  helperText={errors.l_business_name}
                                  error={errors.l_business_name != "" ? true : false}
                                  onBlur={(e) => errors.l_business_name != "" && checkValidation()}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 1 ||
                                      formData?.l_phase === 8 ||
                                      formData?.l_phase === 4 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  required
                                  autoComplete="off"
                                  type="text"
                                  label="Business Category"
                                  name="l_business_category"
                                  value={formData?.l_business_category}
                                  onChange={(e) => {
                                    if (e.target.value.length <= 60) {
                                      onChangeFunction(e);
                                    }
                                  }}
                                  inputProps={{ maxLength: 60 }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end" style={{ fontSize: "12px" }}>
                                        {formData?.l_business_category?.length || 0}/60
                                      </InputAdornment>
                                    )
                                  }}
                                  autoCorrect="off"
                                  helperText={errors.l_business_category}
                                  error={errors.l_business_category != "" ? true : false}
                                  onBlur={(e) =>
                                    errors.l_business_category != "" && checkValidation()
                                  }
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 1 ||
                                      formData?.l_phase === 8 ||
                                      formData?.l_phase === 4 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  autoComplete="off"
                                  type="text"
                                  required
                                  label="Email ID"
                                  name="l_email"
                                  value={formData?.l_email}
                                  onChange={onChangeFunction}
                                  autoCorrect="off"
                                  helperText={errors.l_email}
                                  error={errors.l_email != "" ? true : false}
                                  onBlur={(e) => errors.l_email != "" && checkValidation()}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 1 ||
                                      formData?.l_phase === 8 ||
                                      formData?.l_phase === 4 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  // required
                                  autoComplete="off"
                                  type="text"
                                  label="Alternate Contact Number"
                                  name="alternate_contact_number"
                                  value={formData?.alternate_contact_number}
                                  onChange={onChangeFunction}
                                  autoCorrect="off"
                                  onBlur={() =>
                                    errors.alternate_contact_number != "" && checkValidation()
                                  }
                                  id="standard-error-helper-text"
                                  helperText={errors.alternate_contact_number}
                                  error={errors.alternate_contact_number != "" ? true : false}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 1 ||
                                      formData?.l_phase === 8 ||
                                      formData?.l_phase === 4 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                                {/* <ErrorDisplay msg={errors.alternate_contact_number} /> */}
                              </Stack>
                            </Grid>

                            {/* <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <FormControl error={errors.insuranceType != "" ? true : false}>
                                  <FormLabel id="demo-error-radios" style={{ fontWeight: "bold" }}>
                                    Please Select Insurance you have{" "}
                                    <span
                                      aria-hidden="true"
                                      className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                                    >
                                      *
                                    </span>
                                  </FormLabel>
                                  <FormGroup
                                    name="insuranceType"
                                    value={formData?.insuranceType}
                                    onBlur={() => errors.insuranceType != "" && checkValidation()}
                                  >
                                    <FormControlLabel
                                      onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                      value={1}
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 0 ||
                                          formData?.l_phase === 7 ||
                                          formData?.l_phase === 3 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                      control={
                                        <Checkbox
                                          checked={formData.insuranceType.includes("1")}
                                          name="Health_Insurance"
                                        />
                                      }
                                      label="Health Insurance"
                                    />
                                    <FormControlLabel
                                      onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                      value={2}
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 0 ||
                                          formData?.l_phase === 7 ||
                                          formData?.l_phase === 3 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                      control={
                                        <Checkbox
                                          name="Life_Insurance"
                                          checked={formData.insuranceType.includes("2")}
                                        />
                                      }
                                      label="Life Insurance"
                                    />
                                    <FormControlLabel
                                      onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                      value={3}
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 0 ||
                                          formData?.l_phase === 7 ||
                                          formData?.l_phase === 3 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                      control={
                                        <Checkbox
                                          name="Term_Insurance"
                                          checked={formData.insuranceType.includes("3")}
                                        />
                                      }
                                      label="Term Insurance"
                                    />
                                    <FormControlLabel
                                      onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                      value={4}
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 0 ||
                                          formData?.l_phase === 7 ||
                                          formData?.l_phase === 3 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                      control={
                                        <Checkbox
                                          name="None"
                                          checked={formData.insuranceType.includes("4")}
                                        />
                                      }
                                      label="None"
                                    />
                                    <FormControlLabel
                                      value={0}
                                      onChange={(e) => handleInsuranceCheckBoxEvent(e)}
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 0 ||
                                          formData?.l_phase === 7 ||
                                          formData?.l_phase === 3 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                      control={
                                        <Checkbox
                                          name="Other"
                                          checked={formData.insuranceType.includes("0")}
                                        />
                                      }
                                      label="Other"
                                    />

                                    {formData.insuranceType.includes("0") && (
                                      <TextField
                                        // label="Other Option"
                                        variant="standard"
                                        fullWidth
                                        autoComplete="off"
                                        autoCorrect="off"
                                        name="otherInsurance"
                                        placeholder="Other Insurance"
                                        value={formData?.otherInsurance}
                                        onChange={onChangeFunction}

                                      />
                                    )}
                                  </FormGroup>
                                  <FormHelperText>{errors.insuranceType}</FormHelperText>
                                </FormControl>
                              </Stack>
                            </Grid> */}
                            <Grid item xs={12} md={12}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  autoComplete="off"
                                  autoCorrect="off"
                                  type="text"
                                  label="Business Description"
                                  name="l_business_description"
                                  value={formData?.l_business_description}
                                  onChange={onChangeFunction}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 1 ||
                                      formData?.l_phase === 8 ||
                                      formData?.l_phase === 4 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={12}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                {/* <label style={{ fontWeight: "bold" }}>
                          Select Aadhaar Card Front & Back Photo
                        </label> */}
                                <FormControl
                                  error={errors.aadhaar != "" ? true : false}
                                  variant="standard"
                                >
                                  <FormLabel id="demo-error-radios" style={{ fontWeight: "bold" }}>
                                    Select Aadhaar Card Front & Back Photo{" "}
                                    <span
                                      aria-hidden="true"
                                      className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                                    >
                                      *
                                    </span>
                                  </FormLabel>
                                  {/* <TextField type="file" /> */}
                                  <div style={{ margin: "15px 0 0 0" }}>
                                    <div
                                      style={{
                                        minHeight: "70px",
                                        border: "1px dashed #000",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        // margin:'0 0 15px 0',
                                        borderRadius: "10px"
                                      }}
                                    >
                                      <label
                                        className=""
                                        htmlFor="file"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          width: "100%",
                                          height: "-webkit-fill-available",
                                          cursor: "pointer"
                                        }}
                                      >
                                        <Label
                                          disabled={
                                            !(
                                              formData?.status === 0 ||
                                              formData?.l_phase === 1 ||
                                              formData?.l_phase === 8 ||
                                              formData?.l_phase === 4 ||
                                              (formData?.is_edit_form === 1 &&
                                                formData?.l_phase === 2)
                                            ) &&
                                            formData?.type !== 6 &&
                                            true
                                          }
                                          variant="filled"
                                          color={undefined}
                                          // color={
                                          //   // || formData?.is_edit_form == 0
                                          //   !(
                                          //     formData?.status === 0 ||
                                          //     formData?.l_phase === 0 ||
                                          //     formData?.l_phase === 3 ||
                                          //     (formData?.is_edit_form === 1 &&
                                          //       formData?.l_phase === 1)
                                          //   ) && formData?.type !== 6
                                          //     ? undefined
                                          //     : "primary"
                                          // }
                                          style={{
                                            height: "40px",
                                            width: "150px",
                                            cursor: "pointer",
                                            backgroundColor: "transparent"
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center"
                                            }}
                                          >
                                            Select File
                                            <AddPhotoAlternate
                                              style={{
                                                marginLeft: "7px",
                                                height: "16px",
                                                width: "16px"
                                              }}
                                            />
                                          </div>
                                        </Label>
                                        <input
                                          id="file"
                                          type="file"
                                          hidden
                                          name="aadhaar"
                                          accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.bmp"
                                          onChange={(e) => {
                                            handleFileChange(e, "aadhaar");
                                          }}
                                          disabled={
                                            !(
                                              formData?.status === 0 ||
                                              formData?.l_phase === 1 ||
                                              formData?.l_phase === 8 ||
                                              formData?.l_phase === 4 ||
                                              (formData?.is_edit_form === 1 &&
                                                formData?.l_phase === 2)
                                            ) &&
                                            formData?.type !== 6 &&
                                            true
                                          }
                                          onBlur={() => errors.aadhaar != "" && checkValidation()}
                                        // onBlur={checkValidation}
                                        />
                                      </label>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                        alignItems: "center"
                                      }}
                                    >
                                      <>
                                        {formData?.aadhaar && (
                                          <div
                                            variant={"ghost"}
                                            color="success"
                                            style={{
                                              margin: "10px auto",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              width: "fit-content",
                                              paddingBottom: "5px",
                                              paddingTop: "5px",
                                              fontSize: "14px",
                                              cursor: "default",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              padding: "0px 8px",
                                              color: "#229A16",
                                              fontSize: "0.75rem",
                                              backgroundColor: "rgba(84, 214, 44, 0.16)",
                                              fontWeight: "700",
                                              borderRadius: "8px"
                                            }}
                                          >
                                            {formData?.aadhaar?.name}
                                          </div>
                                        )}
                                        {/* <div>
                                  {allowedFileTypes.includes(
                                    formData?.aadhaar?.type
                                  ) && (
                                    <div>
                                      {formData?.aadhaar?.type.startsWith(
                                        "image/"
                                      ) && (
                                        <img
                                          src={URL.createObjectURL(
                                            formData?.aadhaar
                                          )}
                                          alt="Preview"
                                          style={{
                                            maxWidth: "100%",
                                            margin: "auto",
                                            maxHeight: "130px",
                                          }}
                                        />
                                      )}
                                      {formData?.aadhaar?.type ===
                                        "application/pdf" && (
                                        <embed
                                          src={URL.createObjectURL(
                                            formData?.aadhaar
                                          )}
                                          width="100%"
                                          height="400px"
                                          type="application/pdf"
                                        />
                                      )}

                                      {(formData?.aadhaar?.type ===
                                        "application/msword" ||
                                        formData?.aadhaar?.type ===
                                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && (
                                        <iframe
                                          src={`https://docs.google.com/gview?url=${encodeURIComponent(
                                            URL.createObjectURL(
                                              formData?.aadhaar
                                            )
                                          )}&embedded=true`}
                                          title="Preview"
                                          width="100%"
                                          height="400px"
                                        />
                                      )}
                                    </div>
                                  )}
                                </div> */}
                                        <div
                                          style={{
                                            marginTop: "20px",
                                            display: "flex",
                                            justifyContent: "center"
                                          }}
                                        >
                                          <FormHelperText>{errors.aadhaar}</FormHelperText>
                                          {/* <ErrorDisplay msg={errors.aadhaar} /> */}
                                        </div>

                                        {/* Input Helper */}
                                        {/* <Label
                                          variant={"ghost"}
                                          color="error"
                                          style={{
                                            margin: "10px 0 10px 0",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "fit-content",
                                            paddingBottom: "5px",
                                            paddingTop: "5px",
                                            fontSize: "14px"
                                          }}
                                        >
                                          More Then 20MB of File Are Not Supported
                                        </Label> */}
                                        <div
                                          style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                          }}
                                        >
                                          <Label
                                            variant={"ghost"}
                                            color="primary"
                                            style={{
                                              margin: "0",
                                              display: "flex",
                                              marginTop: "0px",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              width: "fit-content",
                                              paddingBottom: "5px",
                                              paddingTop: "5px",
                                              fontSize: "14px"
                                            }}
                                          >
                                            Note: PDF, Doc & Images are Only Supported
                                          </Label>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                </FormControl>
                              </Stack>
                            </Grid>
                            {/* <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  type="text"
                                  label="Enter Facebook ID"
                                  name="facebook_url"
                                  value={formData?.facebook_url}
                                  onChange={onChangeFunction}
                                  // onBlur={checkValidation}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 0 ||
                                      formData?.l_phase === 7 ||
                                      formData?.l_phase === 3 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                  autoComplete="off"
                                  autoCorrect="off"
                                />
                                <ErrorDisplay msg={errors.facebook_url} />
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  type="text"
                                  label="Enter Instagram ID"
                                  name="instagram_url"
                                  value={formData?.instagram_url}
                                  onChange={onChangeFunction}
                                  // onBlur={checkValidation}
                                  autoComplete="off"
                                  autoCorrect="off"
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 0 ||
                                      formData?.l_phase === 7 ||
                                      formData?.l_phase === 3 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                                <ErrorDisplay msg={errors.instagram_url} />
                              </Stack>
                            </Grid> */}

                            {/* <Grid container spacing={1.5} style={{ marginTop: "15px" }}> */}

                            {/* <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  autoComplete="off"
                                  autoCorrect="off"
                                  type="text"
                                  label="Business Description"
                                  name="l_business_description"
                                  value={formData?.l_business_description}
                                  onChange={onChangeFunction}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 0 ||
                                      formData?.l_phase === 7 ||
                                      formData?.l_phase === 3 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                              </Stack>
                            </Grid> */}

                            <Grid item xs={12} md={6}>
                              <FormLabel
                                id="demo-row-radio-buttons-group-label"
                                style={{ marginBottom: "0px" }}
                              >
                                Do You have GST?
                              </FormLabel>
                              <RadioGroup
                                style={{ marginTop: "0px", display: "flex", flexFlow: "row" }}
                                row
                                value={formData.pr_gst_verify}
                                onChange={onChangeFunction}
                                aria-labelledby="demo-row-radio-buttons-group-label"
                                name="pr_gst_verify"
                              >
                                <FormControlLabel value="1" control={<Radio />} label="Yes" />
                                <FormControlLabel value="0" control={<Radio />} label="No" />
                              </RadioGroup>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              {formData.pr_gst_verify == 1 ? (
                                <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                  <TextField
                                    style={{ marginTop: "0px" }}
                                    fullWidth
                                    autoComplete="off"
                                    type="text"
                                    label="GST No"
                                    name="gst_no"
                                    value={formData?.gst_no}
                                    onChange={(e) => {
                                      e.target.value = e.target.value.toUpperCase();
                                      onChangeFunction(e);
                                    }}
                                    onBlur={(e) => {
                                      const error = validateGST(e.target.value);
                                      setErrors((prev) => ({
                                        ...prev,
                                        gst_no: error
                                      }));
                                    }}
                                    helperText={errors.gst_no}
                                    error={errors.gst_no != "" ? true : false}
                                    disabled={
                                      !(
                                        formData?.status === 0 ||
                                        formData?.l_phase === 1 ||
                                        formData?.l_phase === 8 ||
                                        formData?.l_phase === 4 ||
                                        (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                      ) &&
                                      formData?.type !== 6 &&
                                      true
                                    }
                                  />
                                  <Button
                                    variant="contained"
                                    size="small"
                                    style={{ marginTop: "8px", alignSelf: "flex-start" }}
                                    onClick={() => fetchGstDetailsbynumber(formData.gst_no)}
                                    disabled={
                                      !formData.gst_no ||
                                      formData.gst_no.length !== 15 ||
                                      (!(
                                        formData?.status === 0 ||
                                        formData?.l_phase === 1 ||
                                        formData?.l_phase === 8 ||
                                        formData?.l_phase === 4 ||
                                        (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                      ) &&
                                        formData?.type !== 6)
                                    }
                                  >
                                    Verify GST No
                                  </Button>
                                  <span
                                    style={{ fontSize: "14px", color: "primary", marginTop: "0px" }}
                                  >
                                    Invoice will be issued as per the provided GST number;
                                    otherwise, it will be billed in your business name, After that,
                                    no changes will be accepted
                                  </span>
                                </Stack>
                              ) : (
                                ""
                              )}
                            </Grid>
                            {formData.pr_gst_verify == 1 && formData.gst_business_name ? (
                              <>
                                <Grid item xs={12} md={6}>
                                  <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                    <TextField
                                      style={{ marginTop: "0px" }}
                                      fullWidth
                                      autoComplete="off"
                                      type="text"
                                      label="Business Name (As Per GST)"
                                      name="gst_business_name"
                                      value={formData?.gst_business_name || ""}
                                      onChange={onChangeFunction}
                                      helperText={
                                        formData.gst_business_name && originalGstBusinessName && formData.gst_business_name.trim() !== originalGstBusinessName.trim()
                                          ? "business name not matched with GST details"
                                          : ""
                                      }
                                      error={
                                        !!(formData.gst_business_name && originalGstBusinessName && formData.gst_business_name.trim() !== originalGstBusinessName.trim())
                                      }
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 1 ||
                                          formData?.l_phase === 8 ||
                                          formData?.l_phase === 4 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                    />
                                  </Stack>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                    <TextField
                                      style={{ marginTop: "0px" }}
                                      fullWidth
                                      autoComplete="off"
                                      multiline
                                      minRows={2}
                                      label="Business Address (As Per GST)"
                                      name="gst_business_address"
                                      value={formData?.gst_business_address || ""}
                                      onChange={onChangeFunction}
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 1 ||
                                          formData?.l_phase === 8 ||
                                          formData?.l_phase === 4 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                    />
                                  </Stack>
                                </Grid>
                              </>
                            ) : (
                              ""
                            )}

                            {/* <Grid item xs={12} md={6} style={{ marginTop: "10px" }}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  autoComplete="off"
                                  type="text"
                                  required
                                  label="Office Address"
                                  name="l_address"
                                  value={formData?.l_address}
                                  onChange={onChangeFunction}
                                  autoCorrect="off"
                                  helperText={errors.l_address}
                                  error={errors.l_address != "" ? true : false}
                                  onBlur={(e) => errors.l_address != "" && checkValidation()}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 0 ||
                                      formData?.l_phase === 7 ||
                                      formData?.l_phase === 3 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                              </Stack>
                            </Grid> */}
                            {/* <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  autoComplete="off"
                                  type="text"
                                  required
                                  label="Home Address"
                                  name="l_h_address"
                                  value={formData?.l_h_address}
                                  onChange={onChangeFunction}
                                  autoCorrect="off"
                                  helperText={errors.l_h_address}
                                  error={errors.l_h_address != "" ? true : false}
                                  onBlur={(e) => errors.l_h_address != "" && checkValidation()}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 0 ||
                                      formData?.l_phase === 7 ||
                                      formData?.l_phase === 3 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                              </Stack>
                            </Grid> */}
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                  <DatePicker
                                    disabled={
                                      !(
                                        formData?.status === 0 ||
                                        formData?.l_phase === 1 ||
                                        formData?.l_phase === 8 ||
                                        formData?.l_phase === 4 ||
                                        (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                      ) &&
                                      formData?.type !== 6 &&
                                      true
                                    }
                                    type="date"
                                    name="payment_date"
                                    label="Payment Date"
                                    // value={
                                    //   formData?.payment_date != ""
                                    //     ? moment(
                                    //         formData?.payment_date,
                                    //         "MM-DD-YYYY"
                                    //       ).format("DD-MM-YYYY")
                                    //     : null
                                    // }
                                    value={
                                      formData?.payment_date != undefined
                                        ? moment(formData.payment_date, "DD-MM-YYYY")
                                        : null
                                    }
                                    inputFormat="dd/MM/yyyy"
                                    onChange={(newDate) => {
                                      setFormData({
                                        ...formData,
                                        payment_date: moment(newDate, "DD-MM-YYYY").format(
                                          "DD-MM-YYYY"
                                        )
                                      });
                                      errors.payment_date != "" && checkValidation();
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        // disabled
                                        {...params}
                                        required
                                        helperText={errors.payment_date}
                                        onBlur={() =>
                                          errors.payment_date != "" && checkValidation()
                                        }
                                        error={errors.payment_date != "" ? true : false}
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                                {/* <ErrorDisplay msg={errors?.payment_date} /> */}
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <FormControl
                                  // disabled={formData?.updateby_member == 1 && true}
                                  error={errors.payment_mode != "" ? true : false}
                                >
                                  <FormLabel
                                    id="demo-error-radios"
                                    style={{ fontWeight: "bold" }}
                                    disabled={
                                      !(
                                        formData?.status === 0 ||
                                        formData?.l_phase === 1 ||
                                        formData?.l_phase === 8 ||
                                        formData?.l_phase === 4 ||
                                        (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                      ) &&
                                      formData?.type !== 6 &&
                                      true
                                    }
                                  >
                                    Please Select Payment Method{" "}
                                    <span
                                      aria-hidden="true"
                                      className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                                    >
                                      *
                                    </span>
                                  </FormLabel>

                                  <RadioGroup
                                    row // display as Row
                                    name="payment_mode"
                                    value={formData?.payment_mode}
                                    required
                                    // onChange={handleOptionChange}
                                    // onBlur={checkValidation}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        payment_mode: e.target.value
                                      });
                                    }}
                                  >
                                    <FormControlLabel
                                      value={0}
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 1 ||
                                          formData?.l_phase === 8 ||
                                          formData?.l_phase === 4 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                      control={<Radio />}
                                      label="Cash"
                                    />
                                    <FormControlLabel
                                      value={1}
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 1 ||
                                          formData?.l_phase === 8 ||
                                          formData?.l_phase === 4 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                      control={<Radio />}
                                      label="Transfer"
                                    />
                                    <FormControlLabel
                                      value={2}
                                      disabled={
                                        !(
                                          formData?.status === 0 ||
                                          formData?.l_phase === 1 ||
                                          formData?.l_phase === 8 ||
                                          formData?.l_phase === 4 ||
                                          (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                        ) &&
                                        formData?.type !== 6 &&
                                        true
                                      }
                                      control={<Radio />}
                                      label="Cheque"
                                    />
                                  </RadioGroup>
                                  <FormHelperText>{errors.payment_mode}</FormHelperText>
                                </FormControl>

                                {/* <ErrorDisplay msg={errors?.payment_mode} /> */}
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <FormControl
                                  error={errors.l_payment_photo != "" ? true : false}
                                  variant="standard"
                                >
                                  <FormLabel
                                    id="demo-error-radios"
                                    style={{ fontWeight: "bold" }}
                                    disabled={
                                      !(
                                        formData?.status === 0 ||
                                        formData?.l_phase === 1 ||
                                        formData?.l_phase === 8 ||
                                        formData?.l_phase === 4 ||
                                        (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                      ) &&
                                      formData?.type !== 6 &&
                                      true
                                    }
                                  >
                                    Upload Payment Screenshot / Cheque Photo{" "}
                                    <span
                                      aria-hidden="true"
                                      class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                                    >
                                      *
                                    </span>
                                  </FormLabel>
                                  <div style={{ margin: "15px 0 0 0" }}>
                                    <div
                                      style={{
                                        minHeight: "70px",
                                        border: "1px dashed #000",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        borderRadius: "10px"
                                      }}
                                    >
                                      <label
                                        className=""
                                        htmlFor="payment_photo"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          width: "100%",
                                          height: "-webkit-fill-available",
                                          cursor: "pointer"
                                        }}
                                      >
                                        <Label
                                          disabled={
                                            !(
                                              formData?.status === 0 ||
                                              formData?.l_phase === 1 ||
                                              formData?.l_phase === 8 ||
                                              formData?.l_phase === 4 ||
                                              (formData?.is_edit_form === 1 &&
                                                formData?.l_phase === 2)
                                            ) &&
                                            formData?.type !== 6 &&
                                            true
                                          }
                                          variant="filled"
                                          color={undefined}
                                          // color={
                                          //   !(
                                          //     formData?.status === 0 ||
                                          //     formData?.l_phase === 0 ||
                                          //     formData?.l_phase === 3 ||
                                          //     (formData?.is_edit_form === 1 &&
                                          //       formData?.l_phase === 1)
                                          //   ) && formData?.type !== 6
                                          //     ? undefined
                                          //     : "primary"
                                          // }
                                          style={{
                                            height: "40px",
                                            width: "150px",
                                            cursor: "pointer",
                                            backgroundColor: "transparent"
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center"
                                            }}
                                          >
                                            Select File
                                            <AddPhotoAlternate
                                              style={{
                                                marginLeft: "7px",
                                                height: "16px",
                                                width: "16px"
                                              }}
                                            />
                                          </div>
                                        </Label>
                                        <input
                                          id="payment_photo"
                                          type="file"
                                          hidden
                                          multiple
                                          name="l_payment_photo"
                                          accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif,.bmp"
                                          onChange={(e) => {
                                            handleFileChange(e, "l_payment_photo");
                                          }}
                                          disabled={
                                            !(
                                              formData?.status === 0 ||
                                              formData?.l_phase === 1 ||
                                              formData?.l_phase === 8 ||
                                              formData?.l_phase === 4 ||
                                              (formData?.is_edit_form === 1 &&
                                                formData?.l_phase === 2)
                                            ) &&
                                            formData?.type !== 6 &&
                                            true
                                          }
                                        // onBlur={checkValidation}
                                        />
                                      </label>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginTop: "20px"
                                      }}
                                    >
                                      <>
                                        {/* {formData?.l_payment_photo && (
                                          <div
                                            variant={"ghost"}
                                            color="success"
                                            style={{
                                              margin: "10px auto",
                                              display: "flex",
                                              marginTop: "20px",

                                              justifyContent: "center",
                                              alignItems: "center",
                                              width: "fit-content",
                                              paddingBottom: "5px",
                                              paddingTop: "5px",
                                              fontSize: "14px",
                                              cursor: "default",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              padding: "0px 8px",
                                              color: "#229A16",
                                              fontSize: "0.75rem",
                                              backgroundColor: "rgba(84, 214, 44, 0.16)",
                                              fontWeight: "700",
                                              borderRadius: "8px"
                                            }}
                                          >
                                            {formData?.l_payment_photo?.name}
                                          </div>
                                        )} */}
                                        {formData?.l_payment_photo &&
                                          formData?.l_payment_photo.length > 0 && (
                                            <div
                                              style={{
                                                margin: "10px auto",
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                gap: "5px"
                                              }}
                                            >
                                              {Array.isArray(formData.l_payment_photo) ? (
                                                formData.l_payment_photo.map((file, index) => (
                                                  <div
                                                    key={index}
                                                    variant={"ghost"}
                                                    color="success"
                                                    style={{
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      width: "fit-content",
                                                      paddingBottom: "5px",
                                                      paddingTop: "5px",
                                                      fontSize: "14px",
                                                      cursor: "default",
                                                      padding: "0px 8px",
                                                      color: "#229A16",
                                                      fontSize: "0.75rem",
                                                      backgroundColor: "rgba(84, 214, 44, 0.16)",
                                                      fontWeight: "700",
                                                      borderRadius: "8px"
                                                    }}
                                                  >
                                                    {file.name}
                                                  </div>
                                                ))
                                              ) : (
                                                <div
                                                  variant={"ghost"}
                                                  color="success"
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignItems: "center",
                                                    width: "fit-content",
                                                    paddingBottom: "5px",
                                                    paddingTop: "5px",
                                                    fontSize: "14px",
                                                    cursor: "default",
                                                    padding: "0px 8px",
                                                    color: "#229A16",
                                                    fontSize: "0.75rem",
                                                    backgroundColor: "rgba(84, 214, 44, 0.16)",
                                                    fontWeight: "700",
                                                    borderRadius: "8px"
                                                  }}
                                                >
                                                  {formData?.l_payment_photo?.name}
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        {/* <div>
                                  {allowedFileTypes.includes(
                                    formData?.aadhaar?.type
                                  ) && (
                                    <div>
                                      {formData?.aadhaar?.type.startsWith(
                                        "image/"
                                      ) && (
                                        <img
                                          src={URL.createObjectURL(
                                            formData?.aadhaar
                                          )}
                                          alt="Preview"
                                          style={{
                                            maxWidth: "100%",
                                            margin: "auto",
                                            maxHeight: "130px",
                                          }}
                                        />
                                      )}
                                      {formData?.aadhaar?.type ===
                                        "application/pdf" && (
                                        <embed
                                          src={URL.createObjectURL(
                                            formData?.aadhaar
                                          )}
                                          width="100%"
                                          height="400px"
                                          type="application/pdf"
                                        />
                                      )}

                                      {(formData?.aadhaar?.type ===
                                        "application/msword" ||
                                        formData?.aadhaar?.type ===
                                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && (
                                        <iframe
                                          src={`https://docs.google.com/gview?url=${encodeURIComponent(
                                            URL.createObjectURL(
                                              formData?.aadhaar
                                            )
                                          )}&embedded=true`}
                                          title="Preview"
                                          width="100%"
                                          height="400px"
                                        />
                                      )}
                                    </div>
                                  )}
                                </div> */}
                                        <div
                                          style={{
                                            marginTop: "20px",
                                            display: "flex",
                                            justifyContent: "center"
                                          }}
                                        >
                                          <FormHelperText>{errors.l_payment_photo}</FormHelperText>
                                        </div>

                                        {/* <Label
                                          variant={"ghost"}
                                          color="error"
                                          style={{
                                            margin: "10px 0 10px 0",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "fit-content",
                                            paddingBottom: "5px",
                                            paddingTop: "5px",
                                            fontSize: "14px"
                                          }}
                                        >
                                          More Then 10MB of File Are Not Supported
                                        </Label> */}
                                        <div
                                          style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                          }}
                                        >
                                          <Label
                                            variant={"ghost"}
                                            color="primary"
                                            style={{
                                              margin: "0",
                                              display: "flex",
                                              marginTop: "0px",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              width: "fit-content",
                                              paddingBottom: "5px",
                                              paddingTop: "5px",
                                              fontSize: "14px"
                                            }}
                                          >
                                            Note: PDF, Doc & Images are Only Supported
                                          </Label>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                </FormControl>
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <FormControl
                                  error={errors.l_professional_photo != "" ? true : false}
                                  variant="standard"
                                >
                                  <FormLabel
                                    id="demo-error-radios"
                                    style={{ fontWeight: "bold" }}
                                    disabled={
                                      !(
                                        formData?.status === 0 ||
                                        formData?.l_phase === 1 ||
                                        formData?.l_phase === 8 ||
                                        formData?.l_phase === 4 ||
                                        (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                      ) &&
                                      formData?.type !== 6 &&
                                      true
                                    }
                                  >
                                    Upload Professional Photo{" "}
                                    <span
                                      aria-hidden="true"
                                      class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                                    >
                                      *
                                    </span>
                                  </FormLabel>
                                  <div style={{ margin: "15px 0 0 0" }}>
                                    <div
                                      style={{
                                        minHeight: "70px",
                                        border: "1px dashed #000",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        cursor: "pointer",
                                        borderRadius: "10px"
                                      }}
                                    >
                                      <label
                                        className=""
                                        htmlFor="l_professional_photo"
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          width: "100%",
                                          height: "-webkit-fill-available",
                                          cursor: "pointer"
                                        }}
                                      >
                                        <Label
                                          disabled={
                                            !(
                                              formData?.status === 0 ||
                                              formData?.l_phase === 1 ||
                                              formData?.l_phase === 8 ||
                                              formData?.l_phase === 4 ||
                                              (formData?.is_edit_form === 1 &&
                                                formData?.l_phase === 2)
                                            ) &&
                                            formData?.type !== 6 &&
                                            true
                                          }
                                          variant="filled"
                                          // color={
                                          //   // || formData?.is_edit_form == 0
                                          //   (formData?.status === 0 ||
                                          //     formData?.l_phase == 6 ||
                                          //     formData?.l_phase == 4 ||
                                          //     !(
                                          //       formData?.is_edit_form === 1 &&
                                          //       formData?.l_phase === 1
                                          //     )) &&
                                          //   formData?.type != 6
                                          //     ? undefined
                                          //     : "primary"
                                          // }
                                          color={undefined}
                                          style={{
                                            height: "40px",
                                            width: "150px",
                                            cursor: "pointer",
                                            backgroundColor: "transparent"
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center"
                                            }}
                                          >
                                            Select File
                                            <AddPhotoAlternate
                                              style={{
                                                marginLeft: "7px",
                                                height: "16px",
                                                width: "16px"
                                              }}
                                            />
                                          </div>
                                        </Label>
                                        <input
                                          id="l_professional_photo"
                                          type="file"
                                          hidden
                                          name="l_professional_photo"
                                          accept=".jpeg,.jpg,.png,.gif"
                                          onChange={(e) =>
                                            handleFileChange(e, "l_professional_photo")
                                          }
                                          disabled={
                                            !(
                                              formData?.status === 0 ||
                                              formData?.l_phase === 1 ||
                                              formData?.l_phase === 8 ||
                                              formData?.l_phase === 4 ||
                                              (formData?.is_edit_form === 1 &&
                                                formData?.l_phase === 2)
                                            ) &&
                                            formData?.type !== 6 &&
                                            true
                                          }
                                        // onBlur={checkValidation}
                                        />
                                      </label>
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        flexWrap: "wrap",
                                        justifyContent: "center",
                                        alignItems: "center"
                                      }}
                                    >
                                      <>
                                        {formData?.l_professional_photo && (
                                          <div
                                            variant={"ghost"}
                                            color="success"
                                            style={{
                                              margin: "10px auto",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              width: "fit-content",
                                              paddingBottom: "5px",
                                              paddingTop: "5px",
                                              fontSize: "14px",
                                              cursor: "default",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              padding: "0px 8px",
                                              color: "#229A16",
                                              fontSize: "0.75rem",
                                              backgroundColor: "rgba(84, 214, 44, 0.16)",
                                              fontWeight: "700",
                                              borderRadius: "8px"
                                            }}
                                          >
                                            {formData?.l_professional_photo?.name}
                                          </div>
                                        )}
                                        {/* <div>
                                  {allowedFileTypes.includes(
                                    formData?.aadhaar?.type
                                  ) && (
                                    <div>
                                      {formData?.aadhaar?.type.startsWith(
                                        "image/"
                                      ) && (
                                        <img
                                          src={URL.createObjectURL(
                                            formData?.aadhaar
                                          )}
                                          alt="Preview"
                                          style={{
                                            maxWidth: "100%",
                                            margin: "auto",
                                            maxHeight: "130px",
                                          }}
                                        />
                                      )}
                                      {formData?.aadhaar?.type ===
                                        "application/pdf" && (
                                        <embed
                                          src={URL.createObjectURL(
                                            formData?.aadhaar
                                          )}
                                          width="100%"
                                          height="400px"
                                          type="application/pdf"
                                        />
                                      )}

                                      {(formData?.aadhaar?.type ===
                                        "application/msword" ||
                                        formData?.aadhaar?.type ===
                                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && (
                                        <iframe
                                          src={`https://docs.google.com/gview?url=${encodeURIComponent(
                                            URL.createObjectURL(
                                              formData?.aadhaar
                                            )
                                          )}&embedded=true`}
                                          title="Preview"
                                          width="100%"
                                          height="400px"
                                        />
                                      )}
                                    </div>
                                  )}
                                </div> */}
                                        <div
                                          style={{
                                            marginTop: "20px",
                                            display: "flex",
                                            justifyContent: "center"
                                          }}
                                        >
                                          <FormHelperText>
                                            {errors.l_professional_photo}
                                          </FormHelperText>
                                        </div>

                                        {/* <Label
                                          variant={"ghost"}
                                          color="error"
                                          style={{
                                            margin: "10px 0 10px 0",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "fit-content",
                                            paddingBottom: "5px",
                                            paddingTop: "5px",
                                            fontSize: "14px"
                                          }}
                                        >
                                          More Then 10MB of File Are Not Supported
                                        </Label> */}
                                        <div
                                          style={{
                                            width: "100%",
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center"
                                          }}
                                        >
                                          <Label
                                            variant={"ghost"}
                                            color="primary"
                                            style={{
                                              margin: "0",
                                              display: "flex",
                                              marginTop: "0px",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              width: "fit-content",
                                              paddingBottom: "5px",
                                              paddingTop: "5px",
                                              fontSize: "14px"
                                            }}
                                          >
                                            Note: Only Image Supported
                                          </Label>
                                        </div>
                                      </>
                                    </div>
                                  </div>
                                </FormControl>
                              </Stack>
                            </Grid>

                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  required
                                  autoComplete="off"
                                  type="text"
                                  label="Reference By (1)"
                                  name="l_reference_1"
                                  value={formData?.l_reference_1 || ""}
                                  onChange={onChangeFunction}
                                  autoCorrect="off"
                                  helperText={errors.l_reference_1}
                                  error={errors.l_reference_1 != "" ? true : false}
                                  onBlur={(e) => errors.l_reference_1 != "" && checkValidation()}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 1 ||
                                      formData?.l_phase === 8 ||
                                      formData?.l_phase === 4 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                              </Stack>
                            </Grid>
                            <Grid item xs={12} md={6}>
                              <Stack spacing={10} style={{ marginBottom: "15px" }}>
                                <TextField
                                  style={{ marginTop: "0px" }}
                                  fullWidth
                                  required
                                  autoComplete="off"
                                  type="text"
                                  label="Reference By (2)"
                                  name="l_reference_2"
                                  value={formData?.l_reference_2 || ""}
                                  onChange={onChangeFunction}
                                  autoCorrect="off"
                                  helperText={errors.l_reference_2}
                                  error={errors.l_reference_2 != "" ? true : false}
                                  onBlur={(e) => errors.l_reference_2 != "" && checkValidation()}
                                  disabled={
                                    !(
                                      formData?.status === 0 ||
                                      formData?.l_phase === 1 ||
                                      formData?.l_phase === 8 ||
                                      formData?.l_phase === 4 ||
                                      (formData?.is_edit_form === 1 && formData?.l_phase === 2)
                                    ) &&
                                    formData?.type !== 6 &&
                                    true
                                  }
                                />
                              </Stack>
                            </Grid>
                          </Grid>
                          {/* </Grid> */}
                        </>
                      ) : // : activeTab == 2 ? (
                        //   <>
                        //     <Grid container spacing={1.5} style={{ marginTop: "15px" }}>
                        //       <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <TextField
                        //             style={{ marginTop: "0px" }}
                        //             fullWidth
                        //             autoComplete="off"
                        //             type="text"
                        //             required
                        //             label="Company Name"
                        //             name="l_business_name"
                        //             value={formData?.l_business_name}
                        //             onChange={onChangeFunction}
                        //             autoCorrect="off"
                        //             helperText={errors.l_business_name}
                        //             error={errors.l_business_name != "" ? true : false}
                        //             onBlur={(e) => errors.l_business_name != "" && checkValidation()}
                        //             disabled={
                        //               !(
                        //                 formData?.status === 0 ||
                        //                 formData?.l_phase === 0 ||
                        //                 formData?.l_phase === 7 ||
                        //                 formData?.l_phase === 3 ||
                        //                 (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //               ) &&
                        //               formData?.type !== 6 &&
                        //               true
                        //             }
                        //           />
                        //         </Stack>
                        //       </Grid>
                        //       <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <TextField
                        //             style={{ marginTop: "0px" }}
                        //             fullWidth
                        //             required
                        //             autoComplete="off"
                        //             type="text"
                        //             label="Business Category"
                        //             name="l_business_category"
                        //             value={formData?.l_business_category}
                        //             onChange={onChangeFunction}
                        //             autoCorrect="off"
                        //             helperText={errors.l_business_category}
                        //             error={errors.l_business_category != "" ? true : false}
                        //             onBlur={(e) =>
                        //               errors.l_business_category != "" && checkValidation()
                        //             }
                        //             disabled={
                        //               !(
                        //                 formData?.status === 0 ||
                        //                 formData?.l_phase === 0 ||
                        //                 formData?.l_phase === 7 ||
                        //                 formData?.l_phase === 3 ||
                        //                 (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //               ) &&
                        //               formData?.type !== 6 &&
                        //               true
                        //             }
                        //           />
                        //         </Stack>
                        //       </Grid>
                        //       {/* <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <TextField
                        //             style={{ marginTop: "0px" }}
                        //             fullWidth
                        //             autoComplete="off"
                        //             autoCorrect="off"
                        //             type="text"
                        //             label="Business Description"
                        //             name="l_business_description"
                        //             value={formData?.l_business_description}
                        //             onChange={onChangeFunction}
                        //             disabled={
                        //               !(
                        //                 formData?.status === 0 ||
                        //                 formData?.l_phase === 0 ||
                        //                 formData?.l_phase === 7 ||
                        //                 formData?.l_phase === 3 ||
                        //                 (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //               ) &&
                        //               formData?.type !== 6 &&
                        //               true
                        //             }
                        //           />
                        //         </Stack>
                        //       </Grid> */}

                        //       <Grid item xs={12} md={6}>
                        //         <FormLabel
                        //           id="demo-row-radio-buttons-group-label"
                        //           style={{ marginBottom: "0px" }}
                        //         >
                        //           Do You have GST?
                        //         </FormLabel>
                        //         <RadioGroup
                        //           style={{ marginTop: "0px", display: "flex", flexFlow: "row" }}
                        //           row
                        //           value={formData.pr_gst_verify}
                        //           onChange={onChangeFunction}
                        //           aria-labelledby="demo-row-radio-buttons-group-label"
                        //           name="pr_gst_verify"
                        //         >
                        //           <FormControlLabel value="1" control={<Radio />} label="Yes" />
                        //           <FormControlLabel value="0" control={<Radio />} label="No" />
                        //         </RadioGroup>
                        //       </Grid>
                        //       {formData.pr_gst_verify == 1 ? (
                        //         <Grid item xs={12} md={6}>
                        //           <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //             <TextField
                        //               style={{ marginTop: "0px" }}
                        //               fullWidth
                        //               autoComplete="off"
                        //               type="text"
                        //               label="GST No"
                        //               name="gst_no"
                        //               value={formData?.gst_no}
                        //               onChange={onChangeFunction}
                        //               onBlur={(e) => errors.gst_no != "" && checkValidation()}
                        //               helperText={errors.gst_no}
                        //               error={errors.gst_no != "" ? true : false}
                        //               disabled={
                        //                 !(
                        //                   formData?.status === 0 ||
                        //                   formData?.l_phase === 0 ||
                        //                   formData?.l_phase === 7 ||
                        //                   formData?.l_phase === 3 ||
                        //                   (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //                 ) &&
                        //                 formData?.type !== 6 &&
                        //                 true
                        //               }
                        //             />
                        //             <span
                        //               style={{ fontSize: "13px", color: "orange", marginTop: "0px" }}
                        //             >
                        //               Invoice will be issued as per the provided GST number;
                        //               otherwise, it will be billed in your business name, After that,
                        //               no changes will be accepted
                        //             </span>
                        //           </Stack>
                        //         </Grid>
                        //       ) : (
                        //         ""
                        //       )}
                        //       <Grid item xs={12} md={12}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <TextField
                        //             style={{ marginTop: "0px" }}
                        //             fullWidth
                        //             autoComplete="off"
                        //             type="text"
                        //             required
                        //             label="Email ID"
                        //             name="l_email"
                        //             value={formData?.l_email}
                        //             onChange={onChangeFunction}
                        //             autoCorrect="off"
                        //             helperText={errors.l_email}
                        //             error={errors.l_email != "" ? true : false}
                        //             onBlur={(e) => errors.l_email != "" && checkValidation()}
                        //             disabled={
                        //               !(
                        //                 formData?.status === 0 ||
                        //                 formData?.l_phase === 0 ||
                        //                 formData?.l_phase === 7 ||
                        //                 formData?.l_phase === 3 ||
                        //                 (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //               ) &&
                        //               formData?.type !== 6 &&
                        //               true
                        //             }
                        //           />
                        //         </Stack>
                        //       </Grid>
                        //       {/* <Grid item xs={12} md={6} style={{ marginTop: "10px" }}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <TextField
                        //             style={{ marginTop: "0px" }}
                        //             fullWidth
                        //             autoComplete="off"
                        //             type="text"
                        //             required
                        //             label="Office Address"
                        //             name="l_address"
                        //             value={formData?.l_address}
                        //             onChange={onChangeFunction}
                        //             autoCorrect="off"
                        //             helperText={errors.l_address}
                        //             error={errors.l_address != "" ? true : false}
                        //             onBlur={(e) => errors.l_address != "" && checkValidation()}
                        //             disabled={
                        //               !(
                        //                 formData?.status === 0 ||
                        //                 formData?.l_phase === 0 ||
                        //                 formData?.l_phase === 7 ||
                        //                 formData?.l_phase === 3 ||
                        //                 (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //               ) &&
                        //               formData?.type !== 6 &&
                        //               true
                        //             }
                        //           />
                        //         </Stack>
                        //       </Grid> */}
                        //       {/* <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <TextField
                        //             style={{ marginTop: "0px" }}
                        //             fullWidth
                        //             autoComplete="off"
                        //             type="text"
                        //             required
                        //             label="Home Address"
                        //             name="l_h_address"
                        //             value={formData?.l_h_address}
                        //             onChange={onChangeFunction}
                        //             autoCorrect="off"
                        //             helperText={errors.l_h_address}
                        //             error={errors.l_h_address != "" ? true : false}
                        //             onBlur={(e) => errors.l_h_address != "" && checkValidation()}
                        //             disabled={
                        //               !(
                        //                 formData?.status === 0 ||
                        //                 formData?.l_phase === 0 ||
                        //                 formData?.l_phase === 7 ||
                        //                 formData?.l_phase === 3 ||
                        //                 (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //               ) &&
                        //               formData?.type !== 6 &&
                        //               true
                        //             }
                        //           />
                        //         </Stack>
                        //       </Grid> */}
                        //       <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <LocalizationProvider dateAdapter={AdapterDateFns}>
                        //             <DatePicker
                        //               disabled={
                        //                 !(
                        //                   formData?.status === 0 ||
                        //                   formData?.l_phase === 0 ||
                        //                   formData?.l_phase === 7 ||
                        //                   formData?.l_phase === 3 ||
                        //                   (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //                 ) &&
                        //                 formData?.type !== 6 &&
                        //                 true
                        //               }
                        //               type="date"
                        //               name="payment_date"
                        //               label="Payment Date"
                        //               // value={
                        //               //   formData?.payment_date != ""
                        //               //     ? moment(
                        //               //         formData?.payment_date,
                        //               //         "MM-DD-YYYY"
                        //               //       ).format("DD-MM-YYYY")
                        //               //     : null
                        //               // }
                        //               value={
                        //                 formData?.payment_date != undefined
                        //                   ? moment(formData.payment_date, "DD-MM-YYYY")
                        //                   : null
                        //               }
                        //               inputFormat="dd/MM/yyyy"
                        //               onChange={(newDate) => {
                        //                 setFormData({
                        //                   ...formData,
                        //                   payment_date: moment(newDate, "DD-MM-YYYY").format(
                        //                     "DD-MM-YYYY"
                        //                   )
                        //                 });
                        //                 errors.payment_date != "" && checkValidation();
                        //               }}
                        //               renderInput={(params) => (
                        //                 <TextField
                        //                   // disabled
                        //                   {...params}
                        //                   required
                        //                   helperText={errors.payment_date}
                        //                   onBlur={() =>
                        //                     errors.payment_date != "" && checkValidation()
                        //                   }
                        //                   error={errors.payment_date != "" ? true : false}
                        //                 />
                        //               )}
                        //             />
                        //           </LocalizationProvider>
                        //           {/* <ErrorDisplay msg={errors?.payment_date} /> */}
                        //         </Stack>
                        //       </Grid>
                        //       <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <FormControl
                        //             // disabled={formData?.updateby_member == 1 && true}
                        //             error={errors.payment_mode != "" ? true : false}
                        //           >
                        //             <FormLabel
                        //               id="demo-error-radios"
                        //               style={{ fontWeight: "bold" }}
                        //               disabled={
                        //                 !(
                        //                   formData?.status === 0 ||
                        //                   formData?.l_phase === 0 ||
                        //                   formData?.l_phase === 7 ||
                        //                   formData?.l_phase === 3 ||
                        //                   (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //                 ) &&
                        //                 formData?.type !== 6 &&
                        //                 true
                        //               }
                        //             >
                        //               Please Select Payment Method{" "}
                        //               <span
                        //                 aria-hidden="true"
                        //                 className="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                        //               >
                        //                 *
                        //               </span>
                        //             </FormLabel>

                        //             <RadioGroup
                        //               row // display as Row
                        //               name="payment_mode"
                        //               value={formData?.payment_mode}
                        //               required
                        //               // onChange={handleOptionChange}
                        //               // onBlur={checkValidation}
                        //               onChange={(e) => {
                        //                 setFormData({
                        //                   ...formData,
                        //                   payment_mode: e.target.value
                        //                 });
                        //               }}
                        //             >
                        //               <FormControlLabel
                        //                 value={0}
                        //                 disabled={
                        //                   !(
                        //                     formData?.status === 0 ||
                        //                     formData?.l_phase === 0 ||
                        //                     formData?.l_phase === 7 ||
                        //                     formData?.l_phase === 3 ||
                        //                     (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //                   ) &&
                        //                   formData?.type !== 6 &&
                        //                   true
                        //                 }
                        //                 control={<Radio />}
                        //                 label="Cash"
                        //               />
                        //               <FormControlLabel
                        //                 value={1}
                        //                 disabled={
                        //                   !(
                        //                     formData?.status === 0 ||
                        //                     formData?.l_phase === 0 ||
                        //                     formData?.l_phase === 7 ||
                        //                     formData?.l_phase === 3 ||
                        //                     (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //                   ) &&
                        //                   formData?.type !== 6 &&
                        //                   true
                        //                 }
                        //                 control={<Radio />}
                        //                 label="Transfer"
                        //               />
                        //               <FormControlLabel
                        //                 value={2}
                        //                 disabled={
                        //                   !(
                        //                     formData?.status === 0 ||
                        //                     formData?.l_phase === 0 ||
                        //                     formData?.l_phase === 7 ||
                        //                     formData?.l_phase === 3 ||
                        //                     (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //                   ) &&
                        //                   formData?.type !== 6 &&
                        //                   true
                        //                 }
                        //                 control={<Radio />}
                        //                 label="Cheque"
                        //               />
                        //             </RadioGroup>
                        //             <FormHelperText>{errors.payment_mode}</FormHelperText>
                        //           </FormControl>

                        //           {/* <ErrorDisplay msg={errors?.payment_mode} /> */}
                        //         </Stack>
                        //       </Grid>
                        //       <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <FormControl
                        //             error={errors.l_professional_photo != "" ? true : false}
                        //             variant="standard"
                        //           >
                        //             <FormLabel
                        //               id="demo-error-radios"
                        //               style={{ fontWeight: "bold" }}
                        //               disabled={
                        //                 !(
                        //                   formData?.status === 0 ||
                        //                   formData?.l_phase === 0 ||
                        //                   formData?.l_phase === 7 ||
                        //                   formData?.l_phase === 3 ||
                        //                   (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //                 ) &&
                        //                 formData?.type !== 6 &&
                        //                 true
                        //               }
                        //             >
                        //               Upload Professional Photo{" "}
                        //               <span
                        //                 aria-hidden="true"
                        //                 class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                        //               >
                        //                 *
                        //               </span>
                        //             </FormLabel>
                        //             <div>
                        //               <label
                        //                 className=""
                        //                 htmlFor="l_professional_photo"
                        //                 style={{
                        //                   margin: "5px auto",
                        //                   marginTop: "20px",
                        //                   display: "flex",
                        //                   justifyContent: "center"
                        //                 }}
                        //               >
                        //                 <Label
                        //                   disabled={
                        //                     !(
                        //                       formData?.status === 0 ||
                        //                       formData?.l_phase === 0 ||
                        //                       formData?.l_phase === 7 ||
                        //                       formData?.l_phase === 3 ||
                        //                       (formData?.is_edit_form === 1 &&
                        //                         formData?.l_phase === 1)
                        //                     ) &&
                        //                     formData?.type !== 6 &&
                        //                     true
                        //                   }
                        //                   variant="filled"
                        //                   color={
                        //                     // || formData?.is_edit_form == 0
                        //                     (formData?.status === 0 ||
                        //                       formData?.l_phase == 6 ||
                        //                       formData?.l_phase == 4 ||
                        //                       !(
                        //                         formData?.is_edit_form === 1 &&
                        //                         formData?.l_phase === 1
                        //                       )) &&
                        //                     formData?.type != 6
                        //                       ? undefined
                        //                       : "primary"
                        //                   }
                        //                   style={{
                        //                     height: "40px",
                        //                     width: "150px",
                        //                     cursor: "pointer"
                        //                   }}
                        //                 >
                        //                   <div
                        //                     style={{
                        //                       fontSize: "12px",
                        //                       display: "flex",
                        //                       justifyContent: "center",
                        //                       alignItems: "center"
                        //                     }}
                        //                   >
                        //                     Select File
                        //                     <AddPhotoAlternate
                        //                       style={{
                        //                         marginLeft: "7px",
                        //                         height: "16px",
                        //                         width: "16px"
                        //                       }}
                        //                     />
                        //                   </div>
                        //                 </Label>
                        //                 <input
                        //                   id="l_professional_photo"
                        //                   type="file"
                        //                   hidden
                        //                   name="l_professional_photo"
                        //                   accept=".jpeg,.jpg,.png,.gif"
                        //                   onChange={(e) =>
                        //                     handleFileChange(e, "l_professional_photo")
                        //                   }
                        //                   disabled={
                        //                     !(
                        //                       formData?.status === 0 ||
                        //                       formData?.l_phase === 0 ||
                        //                       formData?.l_phase === 7 ||
                        //                       formData?.l_phase === 3 ||
                        //                       (formData?.is_edit_form === 1 &&
                        //                         formData?.l_phase === 1)
                        //                     ) &&
                        //                     formData?.type !== 6 &&
                        //                     true
                        //                   }
                        //                   // onBlur={checkValidation}
                        //                 />
                        //               </label>
                        //               <div>
                        //                 <>
                        //                   {formData?.l_professional_photo && (
                        //                     <div
                        //                       variant={"ghost"}
                        //                       color="success"
                        //                       style={{
                        //                         margin: "10px auto",
                        //                         display: "flex",
                        //                         marginTop: "20px",
                        //                         justifyContent: "center",
                        //                         alignItems: "center",
                        //                         width: "fit-content",
                        //                         paddingBottom: "5px",
                        //                         paddingTop: "5px",
                        //                         fontSize: "14px",
                        //                         cursor: "default",
                        //                         alignItems: "center",
                        //                         justifyContent: "center",
                        //                         padding: "0px 8px",
                        //                         color: "#229A16",
                        //                         fontSize: "0.75rem",
                        //                         backgroundColor: "rgba(84, 214, 44, 0.16)",
                        //                         fontWeight: "700",
                        //                         borderRadius: "8px"
                        //                       }}
                        //                     >
                        //                       {formData?.l_professional_photo?.name}
                        //                     </div>
                        //                   )}
                        //                   {/* <div>
                        //             {allowedFileTypes.includes(
                        //               formData?.aadhaar?.type
                        //             ) && (
                        //               <div>
                        //                 {formData?.aadhaar?.type.startsWith(
                        //                   "image/"
                        //                 ) && (
                        //                   <img
                        //                     src={URL.createObjectURL(
                        //                       formData?.aadhaar
                        //                     )}
                        //                     alt="Preview"
                        //                     style={{
                        //                       maxWidth: "100%",
                        //                       margin: "auto",
                        //                       maxHeight: "130px",
                        //                     }}
                        //                   />
                        //                 )}
                        //                 {formData?.aadhaar?.type ===
                        //                   "application/pdf" && (
                        //                   <embed
                        //                     src={URL.createObjectURL(
                        //                       formData?.aadhaar
                        //                     )}
                        //                     width="100%"
                        //                     height="400px"
                        //                     type="application/pdf"
                        //                   />
                        //                 )}

                        //                 {(formData?.aadhaar?.type ===
                        //                   "application/msword" ||
                        //                   formData?.aadhaar?.type ===
                        //                     "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && (
                        //                   <iframe
                        //                     src={`https://docs.google.com/gview?url=${encodeURIComponent(
                        //                       URL.createObjectURL(
                        //                         formData?.aadhaar
                        //                       )
                        //                     )}&embedded=true`}
                        //                     title="Preview"
                        //                     width="100%"
                        //                     height="400px"
                        //                   />
                        //                 )}
                        //               </div>
                        //             )}
                        //           </div> */}
                        //                   <div
                        //                     style={{
                        //                       marginTop: "20px",
                        //                       display: "flex",
                        //                       justifyContent: "center"
                        //                     }}
                        //                   >
                        //                     <FormHelperText>
                        //                       {errors.l_professional_photo}
                        //                     </FormHelperText>
                        //                   </div>

                        //                   {/* <Label
                        //                     variant={"ghost"}
                        //                     color="error"
                        //                     style={{
                        //                       margin: "10px 0 10px 0",
                        //                       display: "flex",
                        //                       justifyContent: "center",
                        //                       alignItems: "center",
                        //                       width: "fit-content",
                        //                       paddingBottom: "5px",
                        //                       paddingTop: "5px",
                        //                       fontSize: "14px"
                        //                     }}
                        //                   >
                        //                     More Then 10MB of File Are Not Supported
                        //                   </Label> */}
                        //                   <Label
                        //                     variant={"ghost"}
                        //                     color="error"
                        //                     style={{
                        //                       margin: "0",
                        //                       display: "flex",
                        //                       marginTop: "0px",
                        //                       justifyContent: "center",
                        //                       alignItems: "center",
                        //                       width: "fit-content",
                        //                       paddingBottom: "5px",
                        //                       paddingTop: "5px",
                        //                       fontSize: "14px"
                        //                     }}
                        //                   >
                        //                     Note: Only Image Supported
                        //                   </Label>
                        //                 </>
                        //               </div>
                        //             </div>
                        //           </FormControl>
                        //         </Stack>
                        //       </Grid>
                        //       <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <FormControl
                        //             error={errors.l_product_photo != "" ? true : false}
                        //             variant="standard"
                        //           >
                        //             <FormLabel
                        //               id="demo-error-radios"
                        //               style={{ fontWeight: "bold" }}
                        //               disabled={
                        //                 !(
                        //                   formData?.status === 0 ||
                        //                   formData?.l_phase === 0 ||
                        //                   formData?.l_phase === 7 ||
                        //                   formData?.l_phase === 3 ||
                        //                   (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //                 ) &&
                        //                 formData?.type !== 6 &&
                        //                 true
                        //               }
                        //             >
                        //               Upload Your Payment / Check Photo{" "}
                        //               <span
                        //                 aria-hidden="true"
                        //                 class="MuiInputLabel-asterisk MuiFormLabel-asterisk css-1szckaa-MuiFormLabel-asterisk"
                        //               >
                        //                 *
                        //               </span>
                        //             </FormLabel>
                        //             <div>
                        //               <label
                        //                 className=""
                        //                 htmlFor="product_image"
                        //                 style={{
                        //                   margin: "5px auto",
                        //                   marginTop: "20px",
                        //                   display: "flex",
                        //                   justifyContent: "center"
                        //                 }}
                        //               >
                        //                 <Label
                        //                   disabled={
                        //                     !(
                        //                       formData?.status === 0 ||
                        //                       formData?.l_phase === 0 ||
                        //                       formData?.l_phase === 7 ||
                        //                       formData?.l_phase === 3 ||
                        //                       (formData?.is_edit_form === 1 &&
                        //                         formData?.l_phase === 1)
                        //                     ) &&
                        //                     formData?.type !== 6 &&
                        //                     true
                        //                   }
                        //                   variant="filled"
                        //                   color={
                        //                     !(
                        //                       formData?.status === 0 ||
                        //                       formData?.l_phase === 0 ||
                        //                       formData?.l_phase === 3 ||
                        //                       (formData?.is_edit_form === 1 &&
                        //                         formData?.l_phase === 1)
                        //                     ) && formData?.type !== 6
                        //                       ? undefined
                        //                       : "primary"
                        //                   }
                        //                   style={{
                        //                     height: "40px",
                        //                     width: "150px",
                        //                     cursor: "pointer"
                        //                   }}
                        //                 >
                        //                   <div
                        //                     style={{
                        //                       fontSize: "12px",
                        //                       display: "flex",
                        //                       justifyContent: "center",
                        //                       alignItems: "center"
                        //                     }}
                        //                   >
                        //                     Select File
                        //                     <AddPhotoAlternate
                        //                       style={{
                        //                         marginLeft: "7px",
                        //                         height: "16px",
                        //                         width: "16px"
                        //                       }}
                        //                     />
                        //                   </div>
                        //                 </Label>
                        //                 <input
                        //                   id="product_image"
                        //                   type="file"
                        //                   hidden
                        //                   name="l_product_photo"
                        //                   accept=".jpeg,.jpg,.png,.gif"
                        //                   onChange={(e) => {
                        //                     handleFileChange(e, "l_product_photo");
                        //                   }}
                        //                   disabled={
                        //                     !(
                        //                       formData?.status === 0 ||
                        //                       formData?.l_phase === 0 ||
                        //                       formData?.l_phase === 7 ||
                        //                       formData?.l_phase === 3 ||
                        //                       (formData?.is_edit_form === 1 &&
                        //                         formData?.l_phase === 1)
                        //                     ) &&
                        //                     formData?.type !== 6 &&
                        //                     true
                        //                   }
                        //                   // onBlur={checkValidation}
                        //                 />
                        //               </label>
                        //               <div>
                        //                 <>
                        //                   {formData?.l_product_photo && (
                        //                     <div
                        //                       variant={"ghost"}
                        //                       color="success"
                        //                       style={{
                        //                         margin: "10px auto",
                        //                         display: "flex",
                        //                         marginTop: "20px",

                        //                         justifyContent: "center",
                        //                         alignItems: "center",
                        //                         width: "fit-content",
                        //                         paddingBottom: "5px",
                        //                         paddingTop: "5px",
                        //                         fontSize: "14px",
                        //                         cursor: "default",
                        //                         alignItems: "center",
                        //                         justifyContent: "center",
                        //                         padding: "0px 8px",
                        //                         color: "#229A16",
                        //                         fontSize: "0.75rem",
                        //                         backgroundColor: "rgba(84, 214, 44, 0.16)",
                        //                         fontWeight: "700",
                        //                         borderRadius: "8px"
                        //                       }}
                        //                     >
                        //                       {formData?.l_product_photo?.name}
                        //                     </div>
                        //                   )}
                        //                   {/* <div>
                        //             {allowedFileTypes.includes(
                        //               formData?.aadhaar?.type
                        //             ) && (
                        //               <div>
                        //                 {formData?.aadhaar?.type.startsWith(
                        //                   "image/"
                        //                 ) && (
                        //                   <img
                        //                     src={URL.createObjectURL(
                        //                       formData?.aadhaar
                        //                     )}
                        //                     alt="Preview"
                        //                     style={{
                        //                       maxWidth: "100%",
                        //                       margin: "auto",
                        //                       maxHeight: "130px",
                        //                     }}
                        //                   />
                        //                 )}
                        //                 {formData?.aadhaar?.type ===
                        //                   "application/pdf" && (
                        //                   <embed
                        //                     src={URL.createObjectURL(
                        //                       formData?.aadhaar
                        //                     )}
                        //                     width="100%"
                        //                     height="400px"
                        //                     type="application/pdf"
                        //                   />
                        //                 )}

                        //                 {(formData?.aadhaar?.type ===
                        //                   "application/msword" ||
                        //                   formData?.aadhaar?.type ===
                        //                     "application/vnd.openxmlformats-officedocument.wordprocessingml.document") && (
                        //                   <iframe
                        //                     src={`https://docs.google.com/gview?url=${encodeURIComponent(
                        //                       URL.createObjectURL(
                        //                         formData?.aadhaar
                        //                       )
                        //                     )}&embedded=true`}
                        //                     title="Preview"
                        //                     width="100%"
                        //                     height="400px"
                        //                   />
                        //                 )}
                        //               </div>
                        //             )}
                        //           </div> */}
                        //                   <div
                        //                     style={{
                        //                       marginTop: "20px",
                        //                       display: "flex",
                        //                       justifyContent: "center"
                        //                     }}
                        //                   >
                        //                     <FormHelperText>{errors.l_product_photo}</FormHelperText>
                        //                   </div>

                        //                   {/* <Label
                        //                     variant={"ghost"}
                        //                     color="error"
                        //                     style={{
                        //                       margin: "10px 0 10px 0",
                        //                       display: "flex",
                        //                       justifyContent: "center",
                        //                       alignItems: "center",
                        //                       width: "fit-content",
                        //                       paddingBottom: "5px",
                        //                       paddingTop: "5px",
                        //                       fontSize: "14px"
                        //                     }}
                        //                   >
                        //                     More Then 10MB of File Are Not Supported
                        //                   </Label> */}
                        //                   <Label
                        //                     variant={"ghost"}
                        //                     color="error"
                        //                     style={{
                        //                       margin: "0",
                        //                       display: "flex",
                        //                       marginTop: "0px",
                        //                       justifyContent: "center",
                        //                       alignItems: "center",
                        //                       width: "fit-content",
                        //                       paddingBottom: "5px",
                        //                       paddingTop: "5px",
                        //                       fontSize: "14px"
                        //                     }}
                        //                   >
                        //                     Note: Only Image Supported
                        //                   </Label>
                        //                 </>
                        //               </div>
                        //             </div>
                        //           </FormControl>
                        //         </Stack>
                        //       </Grid>
                        //       <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <TextField
                        //             style={{ marginTop: "0px" }}
                        //             fullWidth
                        //             required
                        //             autoComplete="off"
                        //             type="text"
                        //             label="Reference By (1)"
                        //             name="l_reference_1"
                        //             value={formData?.l_reference_1}
                        //             onChange={onChangeFunction}
                        //             autoCorrect="off"
                        //             helperText={errors.l_reference_1}
                        //             error={errors.l_reference_1 != "" ? true : false}
                        //             onBlur={(e) => errors.l_reference_1 != "" && checkValidation()}
                        //             disabled={
                        //               !(
                        //                 formData?.status === 0 ||
                        //                 formData?.l_phase === 0 ||
                        //                 formData?.l_phase === 7 ||
                        //                 formData?.l_phase === 3 ||
                        //                 (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //               ) &&
                        //               formData?.type !== 6 &&
                        //               true
                        //             }
                        //           />
                        //         </Stack>
                        //       </Grid>
                        //       <Grid item xs={12} md={6}>
                        //         <Stack spacing={10} style={{ marginBottom: "15px" }}>
                        //           <TextField
                        //             style={{ marginTop: "0px" }}
                        //             fullWidth
                        //             required
                        //             autoComplete="off"
                        //             type="text"
                        //             label="Reference By (2)"
                        //             name="l_reference_2"
                        //             value={formData?.l_reference_2}
                        //             onChange={onChangeFunction}
                        //             autoCorrect="off"
                        //             helperText={errors.l_reference_2}
                        //             error={errors.l_reference_2 != "" ? true : false}
                        //             onBlur={(e) => errors.l_reference_2 != "" && checkValidation()}
                        //             disabled={
                        //               !(
                        //                 formData?.status === 0 ||
                        //                 formData?.l_phase === 0 ||
                        //                 formData?.l_phase === 7 ||
                        //                 formData?.l_phase === 3 ||
                        //                 (formData?.is_edit_form === 1 && formData?.l_phase === 1)
                        //               ) &&
                        //               formData?.type !== 6 &&
                        //               true
                        //             }
                        //           />
                        //         </Stack>
                        //       </Grid>
                        //     </Grid>
                        //   </>
                        // )
                        null}
                    </Grid>
                  </div>
                  <div
                    style={{
                      margin: "10px auto",
                      display: "flex",
                      justifyContent: "center"
                    }}
                  >
                    {activeTab == 1 && (
                      <Button
                        variant="contained"
                        style={{ margin: "auto 5px" }}
                        // onClick={async () => {
                        //   checkValidation(1);
                        //   checkValidation(2);
                        // }}

                        disabled={isLoading}
                        onClick={submitFormData}
                      >
                        Submit{" "}
                        {isLoading && (
                          <CircularProgress size={14} color="inherit" sx={{ marginLeft: "10px" }} />
                        )}
                      </Button>
                    )}

                    {/* {activeTab == 2 && (
                      <>
                        <Button
                          variant="outlined"
                          style={{ margin: "auto 5px" }}
                          onClick={() => setActiveTab(1)}
                        >
                          Back
                        </Button>
                        <Button
                          variant="contained"
                          style={{ margin: "auto 5px" }}
                          // onClick={async () => {
                          //   checkValidation(1);
                          //   checkValidation(2);
                          // }}

                          disabled={isLoading}
                          onClick={submitFormData}
                        >
                          Submit{" "}
                          {isLoading && (
                            <CircularProgress
                              size={14}
                              color="inherit"
                              sx={{ marginLeft: "10px" }}
                            />
                          )}
                        </Button>
                      </>
                    )} */}
                  </div>

                  {/* {(formData?.l_phase == 6 || formData?.is_edit_form == 0) &&
                    formData?.type != 6 &&
                    activeTab != 3 && (
                      <div
                        style={{
                          display: "block",
                          margin: "auto",
                          width: "fit-content"
                        }}
                      >
                        <Label
                          variant={"ghost"}
                          color="success"
                          style={{
                            margin: "10px 0 10px 0",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "fit-content",
                            paddingBottom: "5px",
                            paddingTop: "5px",
                            fontSize: "14px"
                          }}
                        >
                          You Have Submitted The Form , In Order To Update Contact to LocalVocal
                          Business Group.
                        </Label>
                      </div>
                    )} */}
                </Card>
              </Box>
            )}
          </ContentStyle>
        </Container>
      </Page>
    </>
  );
});
